<!--
Author: TangChen
Date: 2018-11-22
Desc: 修改用户信息组件
 -->
<template>
    <div>
        <div class="comp-user-info comp">
            <div class="comp-user-info-header">修改基本信息</div>
            <el-row class="acct-box">
                <el-form
                    ref="acctInfo"
                    :model="acctInfo"
                    :rules="rules"
                    :label-width="(fn ? '160' : '160') + 'px'"
                    class="acct-form"
                    :class="{ 'certexpdate-box': fn }"
                    v-on:submit.native.prevent
                >
                    <el-col :span="24">
                        <el-form-item label="姓名：" class="form-text">
                            <div class="text-con">
                                {{ acctInfo.custname }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!fn" :span="12">
                        <el-form-item label="证件类型：">
                            <div v-if="!$util.isEmpty(acctInfo.certificatetype)" class="text-con">
                                {{ $cache.getDict("130007", acctInfo.certificatetype) }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!fn || (fn && !isCertexpdate && ocrOnOff)" :span="12">
                        <el-form-item label="证件号码：">
                            <div class="text-con">
                                {{ acctInfo.certificateno }}&emsp;
                                <el-button
                                    v-if="ocrOnOff"
                                    :disabled="ocrStatus"
                                    type="warning"
                                    size="mini"
                                    v-on:click="gotoUpdOcr"
                                >
                                    {{ ocrBtnInfo }}
                                </el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="fn" :span="24">
                        <el-form-item
                            :label="$cache.getDict('130007', acctInfo.certificatetype) + '：'"
                        >
                            <div class="text-con">
                                {{ acctInfo.certificateno }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!fn || (fn && !isBirthdate)" :span="12">
                        <el-form-item
                            label="出生日期："
                            prop="birthday"
                            :class="{ required: !acctInfo.birthday }"
                        >
                            <date-picker
                                v-if="!isBirthdate"
                                :date="birthSet"
                                v-on:date-get="dateBirth"
                            />
                            <div v-if="isBirthdate" class="text-con">
                                {{ $util.fmtDate(acctInfo.birthday) }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!fn" :span="12">
                        <el-form-item label="手机号码：" class="required">
                            <div class="text-con">
                                {{ acctInfo.mobileno }}
                                <span class="modify-phone" v-on:click="modifyPhone">
                                    修改手机号码
                                </span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!fn || (fn && !$cache.getUser().nationality.trim())" :span="12">
                        <el-form-item label="国籍：" prop="nationality" class="required">
                            <el-select
                                v-model.trim="acctInfo.nationality"
                                :disabled="!$util.getConfig().hideFunc"
                                filterable
                                :placeholder="$util.getConfig().hideFunc ? '请选择国籍' : ''"
                            >
                                <el-option
                                    v-for="item in nationality"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!--<el-col v-if="(!fn && acctInfo.nationality=='CN') || (fn && acctInfo.nationality=='CN' && !$cache.getUser().province.trim())" :span="12">
                    <el-form-item label="省份：" prop="province" class="required">
                        <el-select v-model.trim="acctInfo.province" filterable placeholder="请选择省份">
                            <el-option
                                v-for="item in province"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>-->
                    <el-col v-if="!fn || (fn && !isCertexpdate)" :span="12">
                        <el-form-item label="证件有效期：" prop="validdate" class="required">
                            <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                        </el-form-item>
                    </el-col>
                    <!--现居地址-->
                    <el-col
                        v-if="
                            !fn ||
                            (fn &&
                                (($cache.getUser().livingcountry === $const.CN &&
                                    (!$cache.getUser().livingaddressprovince ||
                                        !$cache.getUser().livingaddress ||
                                        !$cache.getUser().livingaddresscity)) ||
                                    !$cache.getUser().livingcountry.trim() ||
                                    !$cache.getUser().livingaddress.trim()))
                        "
                        :span="24"
                    >
                        <country-city-select
                            ref="livingaddress"
                            v-model="livingAddressObj"
                            :hide-func="!$util.getConfig().hideFunc"
                            required
                            class="user-address"
                            country-layout="user"
                            v-on:input="getAdrss"
                        ></country-city-select>
                    </el-col>
                    <el-col
                        v-if="
                            !fn ||
                            (fn &&
                                (($cache.getUser().livingcountry === $const.CN &&
                                    (!$cache.getUser().livingaddressprovince ||
                                        !$cache.getUser().livingaddress ||
                                        !$cache.getUser().livingaddresscity)) ||
                                    !$cache.getUser().livingcountry.trim() ||
                                    !$cache.getUser().livingaddress.trim()))
                        "
                        :span="24"
                    >
                        <el-form-item
                            label="通讯（现居）地址："
                            prop="livingaddress"
                            class="required"
                        >
                            <el-input
                                v-model.trim="acctInfo.livingaddress"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="
                                    $util.getConfig().hideFunc
                                        ? '请输入（现居）通讯地址（例如：xx省xx市xx区xx街道xx号）'
                                        : ''
                                "
                                :maxlength="32"
                                :style="fn ? '' : 'width: 87%;'"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!fn || (fn && !$cache.getUser().annualincome.trim())" :span="12">
                        <el-form-item label="年收入（元）：" prop="annualincome">
                            <el-input
                                v-model.trim="acctInfo.annualincome"
                                placeholder="请输入年收入金额   "
                                :maxlength="16"
                                @input="handleAnnualIncomeInput"
                            />
                        </el-form-item>
                    </el-col>
                    <!-- <el-col
                        v-if="!fn || (fn && !$cache.getUser().specialpersonflag.trim())"
                        :span="12"
                    >
                        <el-form-item
                            label="特定自然人标识："
                            prop="specialpersonflag"
                            class="required"
                        >
                            <el-select
                                v-model.trim="acctInfo.specialpersonflag"
                                :disabled="!$util.getConfig().hideFunc"
                                filterable
                                :placeholder="
                                    $util.getConfig().hideFunc ? '请选择特定自然人标识' : ''
                                "
                            >
                                <el-option
                                    v-for="item in specialpersonflag"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <!--<el-col v-if="!fn || (fn && !$cache.getUser().isdigniaryorceo.trim())" :span="12">-->
                    <!--<el-form-item label="受益人类型：" prop="isdigniaryorceo" class="required">-->
                    <!--<el-select v-model.trim="acctInfo.isdigniaryorceo" filterable placeholder="请选择受益人类型">-->
                    <!--<el-option-->
                    <!--v-for="item in isdigniaryorceo"-->
                    <!--:key="item.subitem"-->
                    <!--:label="item.subitemname"-->
                    <!--:value="item.subitem"-->
                    <!--/>-->
                    <!--</el-select>-->
                    <!--</el-form-item>-->
                    <!--</el-col>-->
                    <el-col
                        v-if="
                            acctInfo.specialpersonflag !== '0' && acctInfo.specialpersonflag !== 'A'
                        "
                        :span="12"
                    >
                        <el-form-item
                            label="财产和资金来源："
                            prop="assetssource"
                            :class="
                                acctInfo.specialpersonflag !== '0' &&
                                acctInfo.specialpersonflag !== 'A'
                                    ? 'required'
                                    : ''
                            "
                        >
                            <el-input
                                v-model.trim="acctInfo.assetssource"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="
                                    $util.getConfig().hideFunc ? '请输入财产和资金来源' : ''
                                "
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!fn || (fn && !$cache.getUser().vocationcode.trim())" :span="12">
                        <el-form-item label="职业：" prop="vocationcode" class="required">
                            <el-select
                                v-model.trim="acctInfo.vocationcode"
                                :disabled="!$util.getConfig().hideFunc"
                                filterable
                                :placeholder="$util.getConfig().hideFunc ? '请选择职业' : ''"
                            >
                                <el-option
                                    v-for="item in vocationcode"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col
                        v-if="
                            (!fn && acctInfo.vocationcode === '14') ||
                            acctInfo.vocationcode === '29'
                        "
                        :span="12"
                    >
                        <el-form-item
                            label="职业补充信息："
                            prop="vocationsupple"
                            :class="{
                                required:
                                    acctInfo.vocationcode === '14' || acctInfo.vocationcode === '29'
                            }"
                        >
                            <el-input
                                v-model.trim="acctInfo.vocationsupple"
                                placeholder="请输入职业补充信息"
                                :maxlength="22"
                            />
                        </el-form-item>
                    </el-col> -->
                    <el-col
                        v-if="!fn || (fn && !$cache.getUser().educationlevel.trim())"
                        :span="12"
                    >
                        <el-form-item label="学历：" prop="educationlevel" class="required">
                            <el-select
                                v-model="acctInfo.educationlevel"
                                :disabled="!$util.getConfig().hideFunc"
                                filterable
                                :placeholder="$util.getConfig().hideFunc ? '请选择学历' : ''"
                            >
                                <el-option
                                    v-for="item in educationlevel"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!fn || (fn && !isDelivertype)" :span="12">
                        <el-form-item label="对账单寄送周期：" prop="delivertype" class="required">
                            <el-select
                                v-model.trim="acctInfo.delivertype"
                                :disabled="!$util.getConfig().hideFunc"
                                filterable
                                :placeholder="
                                    $util.getConfig().hideFunc ? '请选择对账单寄送周期' : ''
                                "
                            >
                                <el-option
                                    v-for="item in delivertype"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!fn || (fn && !isDelivertype)" :span="12">
                        <el-form-item
                            label="对账单寄送方式："
                            prop="deliverway"
                            :class="acctInfo.delivertype === '1' ? '' : 'required'"
                        >
                            <el-select
                                v-model="acctInfo.deliverway"
                                :placeholder="
                                    $util.getConfig().hideFunc ? '请选择对账单寄送方式' : ''
                                "
                                :disabled="
                                    !$util.getConfig().hideFunc || acctInfo.delivertype === '1'
                                "
                                multiple
                                maxlength="32"
                                clearable
                            >
                                <el-option
                                    v-for="item in deliverways"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="(!fn && acctInfo.certificatetype !== '0') || ocrOnOff" :span="12">
                        <el-form-item class="radio-list" label="性别：" prop="sex">
                            <el-radio-group v-model.trim="acctInfo.sex" :disabled="true">
                                <el-radio
                                    v-for="item in sex"
                                    :key="item.subitem"
                                    :label="item.subitem"
                                >
                                    {{ item.subitemname }}
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!fn || (fn && $cache.getUser().postcode == '')" :span="12">
                        <el-form-item label="邮政编码：" prop="postcode" class="required">
                            <el-input
                                v-model.trim="acctInfo.postcode"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请输入邮政编码' : ''"
                                :maxlength="6"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!fn || (fn && $cache.getUser().email == '')" :span="12">
                        <el-form-item label="电子邮箱：" prop="email" class="required">
                            <el-input
                                v-model.trim="acctInfo.email"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请输入电子邮箱' : ''"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col
                        v-if="
                            !fn ||
                            (fn &&
                                (!$cache.getUser().telcycode.trim() ||
                                    !$cache.getUser().telareacode.trim() ||
                                    !$cache.getUser().telno.trim()))
                        "
                        :span="24"
                    >
                        <el-form-item label="电话号码：" prop="telno">
                            <el-select
                                v-model="acctInfo.telcycode"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请选择国家码' : ''"
                                style="width: 150px !important"
                            >
                                <el-option
                                    v-for="item in telcycode"
                                    :key="item.subitem"
                                    :label="item.subitemname + ' ' + item.subitem"
                                    :value="item.subitem"
                                />
                            </el-select>
                            <el-select
                                v-if="acctInfo.telcycode == '86'"
                                v-model="acctInfo.telareacode"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请选择地区码' : ''"
                                style="width: 150px !important"
                                filterable
                                :filter-method="filterMethod"
                                v-on:focus="handleFilter"
                                v-on:change="handleFilter"
                            >
                                <el-option
                                    v-for="item in telareacode"
                                    :key="item.subitem"
                                    :label="item.subitemname + ' ' + item.subitem"
                                    :value="item.subitem"
                                >
                                    <div>
                                        {{ item.subitemname + " " + item.subitem }}
                                    </div>
                                </el-option>
                            </el-select>
                            <el-input
                                v-else
                                v-model.trim="acctInfo.telnoareacodeinput"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请输入地区码' : ''"
                                style="width: 150px !important"
                            />
                            <el-input
                                v-model.trim="acctInfo.telno"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请输入电话号码' : ''"
                                :maxlength="11"
                                style="width: 300px; margin-left: 10px"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="!fn || (fn && !$cache.getUser().fax.trim())" :span="24">
                        <el-form-item
                            v-if="acctInfo.deliverway.includes('2')"
                            label="传真号码："
                            prop="fax"
                            :class="{ required: acctInfo.deliverway.includes('2') }"
                            class="required"
                        >
                            <el-select
                                v-model="acctInfo.faxcycode"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请选择国家码' : ''"
                                style="width: 150px !important"
                            >
                                <el-option
                                    v-for="item in telcycode"
                                    :key="item.subitem"
                                    :label="item.subitemname + ' ' + item.subitem"
                                    :value="item.subitem"
                                />
                            </el-select>
                            <el-select
                                v-if="acctInfo.faxcycode == '86'"
                                v-model="acctInfo.faxareacode"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请选择地区码' : ''"
                                style="width: 150px !important"
                                filterable
                                :filter-method="filterMethod"
                                v-on:focus="handleFilter"
                                v-on:change="handleFilter"
                            >
                                <el-option
                                    v-for="item in telareacode"
                                    :key="item.subitem"
                                    :label="item.subitemname + ' ' + item.subitem"
                                    :value="item.subitem"
                                >
                                    <div>
                                        {{ item.subitemname + " " + item.subitem }}
                                    </div>
                                </el-option>
                            </el-select>
                            <el-input
                                v-else
                                v-model.trim="acctInfo.faxareacodeinput"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请输入地区码' : ''"
                                style="width: 150px !important"
                            />
                            <el-input
                                v-model.trim="acctInfo.fax"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请输入传真号码' : ''"
                                :maxlength="8"
                                style="width: 300px"
                            />
                        </el-form-item>
                    </el-col>

                    <template v-if="acctInfo.proxynationality || acctInfo.proxyname">
                        <!--代理人信息-->
                        <el-col class="title-bar">
                            <div class="bar"></div>
                            <div class="amount">代理人</div>
                        </el-col>
                        <el-col class="el-row-common" :span="12">
                            <el-form-item label="国籍:" prop="proxynationality" class="required">
                                <el-select
                                    v-model.trim="acctInfo.proxynationality"
                                    placeholder="请选择国籍"
                                >
                                    <el-option
                                        v-for="item in nationality"
                                        :key="item.subitem"
                                        :label="item.subitemname"
                                        :value="item.subitem"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col class="el-row-common" :span="12">
                            <el-form-item label="代理人姓名：" class="required" prop="proxyname">
                                <el-input
                                    v-model.trim="acctInfo.proxyname"
                                    placeholder="请输入代理人姓名"
                                    :maxlength="acctInfo.proxycertype === '0B' ? 46 : 20"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="证件类型：" class="required" prop="proxycertype">
                                <el-select
                                    v-model="acctInfo.proxycertype"
                                    placeholder="请选择代理人证件类型"
                                    v-on:change="changeProxyTypeFn"
                                >
                                    <el-option
                                        v-for="item in certTypes"
                                        :key="item.subitem"
                                        :label="item.subitemname"
                                        :value="item.subitem"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col class="el-row-common" :span="12">
                            <el-form-item label="证件号码：" class="required" prop="proxycerno">
                                <el-input
                                    v-model.trim="acctInfo.proxycerno"
                                    placeholder="请输入代理人证件号码"
                                    :maxlength="20"
                                    v-on:blur="changeProxyTypeFn"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="出生日期："
                                prop="proxybirthday"
                                class="birthdate-select required"
                            >
                                <date-picker
                                    :date="proxyDateSetBirth"
                                    v-on:date-get="proxyDateInterval_birth"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="证件有效期："
                                class="required"
                                prop="proxyvaliddate"
                            >
                                <date-picker
                                    :date="proxyvaliddate"
                                    v-on:date-get="proxyDateInterval"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="职业：" class="required" prop="proxyduties">
                                <el-select
                                    v-model.trim="acctInfo.proxyduties"
                                    filterable
                                    placeholder="请选择职业"
                                >
                                    <el-option
                                        v-for="item in proxyduties"
                                        :key="item.subitem"
                                        :label="item.subitemname"
                                        :value="item.subitem"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                class="radio-list required"
                                label="性别："
                                prop="proxysex"
                            >
                                <el-radio-group
                                    v-model.trim="acctInfo.proxysex"
                                    :disabled="proxySexDis"
                                >
                                    <el-radio
                                        v-for="item in sex"
                                        :key="item.subitem"
                                        :label="item.subitem"
                                    >
                                        {{ item.subitemname }}
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="电话号码："
                                prop="proxymobileno"
                                class="proxy-telno-info required"
                            >
                                <el-select
                                    v-model="acctInfo.proxymobilecycode"
                                    placeholder="请选择国家码"
                                    style="width: 150px !important"
                                >
                                    <el-option
                                        v-for="item in proxymobilecycode"
                                        :key="item.subitem"
                                        :label="item.subitemname + ' ' + item.subitem"
                                        :value="item.subitem"
                                    />
                                </el-select>
                                <el-input
                                    v-model.trim="acctInfo.proxymobileno"
                                    style="margin-left: 2px; width: 300px"
                                    placeholder="请输入电话号码"
                                    :maxlength="11"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="通讯（现居）地址："
                                prop="proxyaddress"
                                class="proxy-address-info required"
                            >
                                <el-input
                                    v-model.trim="acctInfo.proxyaddress"
                                    placeholder="请输入（现居）通讯地址（例如：xx省xx市xx区xx街道xx号）"
                                    :maxlength="32"
                                    style="width: 87%"
                                />
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="电子邮箱：" class="required" prop="proxyemail">
                                <el-input
                                    v-model.trim="acctInfo.proxyemail"
                                    placeholder="电子邮箱"
                                    :maxlength="32"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="邮政编码：" class="required" prop="proxypostcode">
                                <el-input
                                    v-model.trim="acctInfo.proxypostcode"
                                    placeholder="请输入邮政编码"
                                    :maxlength="6"
                                />
                            </el-form-item>
                        </el-col>
                    </template>

                    <!--受益人信息-->
                    <!-- <el-col style="margin-bottom: 20px">
                    <div class="border"></div>
                </el-col> -->
                    <el-col class="title-bar">
                        <div class="bar"></div>
                        <div class="amount">实际受益人</div>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="受益人类型：" class="required">
                            <el-select
                                v-model.trim="acctInfo.benefisself"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请选择受益人类型' : ''"
                            >
                                <el-option
                                    v-for="item in benefisself"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!--<el-col v-if="!fn && acctInfo.benefisself==='0'" :span="12">-->
                    <!--<el-form-item label="收入来源：" prop="assetssource" :class="(acctInfo.benefisself==='1')?'required':''">-->
                    <!--<el-input v-model.trim="acctInfo.assetssource" placeholder="请输入收入来源" :maxlength="20" />-->
                    <!--</el-form-item>-->
                    <!--</el-col>-->
                    <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                        <el-form-item label="账户实际受益人：" prop="benefitname" class="required">
                            <el-input
                                v-model.trim="acctInfo.benefitname"
                                :disabled="
                                    acctInfo.benefitcertificatetype == '00' ||
                                    !$util.getConfig().hideFunc
                                "
                                :placeholder="$util.getConfig().hideFunc ? '请输入受益人姓名' : ''"
                                :maxlength="acctInfo.benefitcertificatetype === '0B' ? 46 : 20"
                                v-on:blur="changeInfoFn('benefitname')"
                                v-on:focus="focusInfoFn('benefitname')"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                        <el-form-item
                            label="受益人证件类型："
                            prop="benefitcertificatetype"
                            class="required"
                        >
                            <el-select
                                v-model.trim="acctInfo.benefitcertificatetype"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="
                                    $util.getConfig().hideFunc ? '请选择受益人证件类型' : ''
                                "
                                v-on:change="changeBenefitTypeFn"
                            >
                                <el-option
                                    v-for="item in benefitcertificatetype"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                            <el-button
                                v-show="ocrUpdBtnS"
                                :disabled="ocrDis"
                                type="primary"
                                v-on:click="ocrShow2 = true"
                            >
                                {{ ocrBtnText }}
                            </el-button>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                        <el-form-item
                            label="受益人证件号码："
                            prop="benefitcertificateno"
                            class="required"
                        >
                            <el-input
                                v-model.trim="acctInfo.benefitcertificateno"
                                :disabled="
                                    acctInfo.benefitcertificatetype == '00' ||
                                    !$util.getConfig().hideFunc
                                "
                                :placeholder="
                                    $util.getConfig().hideFunc ? '请输入受益人证件号码' : ''
                                "
                                :maxlength="32"
                                v-on:blur="changeBenefitTypeFn"
                                v-on:focus="focusBenefitTypeFn"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col
                        v-if="
                            (!fn && acctInfo.benefisself === '0') || (fn && !isBeneficiarydateflag)
                        "
                        :span="12"
                    >
                        <el-form-item
                            label="受益人证件有效期："
                            prop="benefitvaliddate"
                            class="required"
                        >
                            <date-picker
                                ref="beneficiaryDateSet"
                                :date="beneficiaryDateSet"
                                v-on:date-get="beneficiaryDateInterval"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                        <el-form-item class="radio-list required" label="性别：" prop="benefitsex">
                            <el-radio-group
                                v-model.trim="acctInfo.benefitsex"
                                :disabled="!$util.getConfig().hideFunc || benefitSexDis"
                            >
                                <el-radio
                                    v-for="item in benefitsex"
                                    :key="item.subitem"
                                    :label="item.subitem"
                                >
                                    {{ item.subitemname }}
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                        <el-form-item
                            label="受益人出生日期："
                            prop="benefitbirthday"
                            class="required"
                        >
                            <date-picker
                                :date="beneficiaryBirthSet"
                                v-on:date-get="beneficiaryDateBirth"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                        <el-form-item label="受益人职业：" class="required" prop="benefitvocation">
                            <el-select
                                v-model.trim="acctInfo.benefitvocation"
                                :disabled="!$util.getConfig().hideFunc"
                                filterable
                                :placeholder="$util.getConfig().hideFunc ? '请选择职业' : ''"
                            >
                                <el-option
                                    v-for="item in benefitvocation"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.benefisself === '0'" :span="24">
                        <el-form-item label="手机号码：" class="required" prop="benefittelno">
                            <!-- <el-select
                                v-model="acctInfo.benefittelnocycode"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请选择国家码' : ''"
                                style="width: 150px !important"
                            >
                                <el-option
                                    v-for="item in benefittelnocycode"
                                    :key="item.subitem"
                                    :label="item.subitemname + ' ' + item.subitem"
                                    :value="item.subitem"
                                />
                            </el-select>
                            <el-select
                                v-if="acctInfo.benefittelnocycode == '86'"
                                v-model="acctInfo.benefittelnoareacode"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请选择地区码' : ''"
                                style="width: 150px !important"
                                filterable
                                :filter-method="filterMethod"
                                v-on:focus="handleFilter"
                                v-on:change="handleFilter"
                            >
                                <el-option
                                    v-for="item in telareacode"
                                    :key="item.subitem"
                                    :label="item.subitemname + ' ' + item.subitem"
                                    :value="item.subitem"
                                >
                                    <div>
                                        {{ item.subitemname + " " + item.subitem }}
                                    </div>
                                </el-option>
                            </el-select>
                            <el-input
                                v-else
                                v-model.trim="acctInfo.beneficiarytelnoareacodeinput"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请输入地区码' : ''"
                                style="width: 150px !important"
                            /> -->
                            <el-input
                                v-model.trim="acctInfo.benefittelno"
                                :disabled="!$util.getConfig().hideFunc"
                                style="margin-left: 2px; width: 300px"
                                :placeholder="
                                    $util.getConfig().hideFunc ? '请输入账户受益人的手机号码' : ''
                                "
                                :maxlength="11"
                                v-on:blur="changeInfoFn('benefittelno')"
                                v-on:focus="focusInfoFn('benefittelno')"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.benefisself === '0'" :span="24">
                        <country-city-select
                            ref="benefAddressObj"
                            v-model="benefAddressObj"
                            :hide-func="!$util.getConfig().hideFunc"
                            required
                            class="user-address"
                            country-layout="user"
                            v-on:input="getBenefAdrss"
                        ></country-city-select>
                    </el-col>
                    <el-col v-if="acctInfo.benefisself === '0'" :span="24">
                        <el-form-item
                            label="通讯（现居）地址："
                            prop="benefitaddress"
                            class="required"
                        >
                            <el-input
                                v-model.trim="acctInfo.benefitaddress"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="
                                    $util.getConfig().hideFunc
                                        ? '请输入（现居）通讯地址（例如：xx省xx市xx区xx街道xx号）'
                                        : ''
                                "
                                :maxlength="32"
                                style="width: 87%"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                        <el-form-item label="电子邮箱：" prop="benefitemail" class="required">
                            <el-input
                                v-model.trim="acctInfo.benefitemail"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请输入电子邮箱' : ''"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                        <el-form-item label="邮政编码：" prop="benefitpostcode" class="required">
                            <el-input
                                v-model.trim="acctInfo.benefitpostcode"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请输入邮政编码' : ''"
                                :maxlength="6"
                            />
                        </el-form-item>
                    </el-col>
                    <!--<el-col v-if="acctInfo.benefisself==='0'" :span="12">
                    <el-form-item label="受益人与持有人关系：" prop="benefrelation" class="required">
                        <el-input v-model.trim="acctInfo.benefrelation" placeholder="请输入受益人与持有人关系" />
                    </el-form-item>
                </el-col>-->

                    <!--控制人信息-->
                    <el-col class="title-bar">
                        <div class="bar"></div>
                        <div class="amount">实际控制人</div>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="控制人类型：" prop="actualisself" class="required">
                            <el-select
                                v-model.trim="acctInfo.actualisself"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请选择受益人类型' : ''"
                            >
                                <el-option
                                    v-for="item in actualisself"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                        <el-form-item
                            label="账户实际控制人："
                            prop="actualctrlname"
                            class="required"
                        >
                            <el-input
                                v-model.trim="acctInfo.actualctrlname"
                                :disabled="
                                    acctInfo.actualctrlcertype == '00' ||
                                    !$util.getConfig().hideFunc
                                "
                                :placeholder="$util.getConfig().hideFunc ? '请输入控制人姓名' : ''"
                                :maxlength="acctInfo.actualctrlcertype === '0B' ? 46 : 20"
                                v-on:blur="changeInfoFn('actualctrlname')"
                                v-on:focus="focusInfoFn('actualctrlname')"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                        <el-form-item
                            label="控制人证件类型："
                            prop="actualctrlcertype"
                            class="required"
                        >
                            <el-select
                                v-model.trim="acctInfo.actualctrlcertype"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="
                                    $util.getConfig().hideFunc ? '请选择控制人证件类型' : ''
                                "
                                v-on:change="changeActualctrlTypeFn"
                            >
                                <el-option
                                    v-for="item in actualctrlcertype"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                            <el-button
                                v-show="ocrUpdBtnS2"
                                :disabled="ocrDis2"
                                type="primary"
                                v-on:click="ocrShow3 = true"
                            >
                                {{ ocrBtnText }}
                            </el-button>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                        <el-form-item
                            label="控制人证件号码："
                            prop="actualctrlcerno"
                            class="required"
                        >
                            <el-input
                                v-model.trim="acctInfo.actualctrlcerno"
                                :disabled="
                                    acctInfo.actualctrlcertype == '00' ||
                                    !$util.getConfig().hideFunc
                                "
                                :placeholder="
                                    $util.getConfig().hideFunc ? '请输入控制人证件号码' : ''
                                "
                                :maxlength="32"
                                v-on:blur="changeActualctrlTypeFn"
                                v-on:focus="focusActualctrlTypeFn"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col
                        v-if="
                            (!fn && acctInfo.actualisself === '0') ||
                            (fn && !isactualctrlvalidateflag)
                        "
                        :span="12"
                    >
                        <el-form-item
                            label="控制人证件有效期："
                            prop="actualctrlvalidate"
                            class="required"
                        >
                            <date-picker
                                ref="actualctrlDateSet"
                                :date="actualctrlDateSet"
                                v-on:date-get="actualctrlDateInterval"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                        <el-form-item
                            class="radio-list required"
                            label="性别："
                            prop="actualctrlsex"
                        >
                            <el-radio-group
                                v-model.trim="acctInfo.actualctrlsex"
                                :disabled="!$util.getConfig().hideFunc || actualSexDis"
                            >
                                <el-radio
                                    v-for="item in actualctrlsex"
                                    :key="item.subitem"
                                    :label="item.subitem"
                                >
                                    {{ item.subitemname }}
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                        <el-form-item
                            label="控制人出生日期："
                            prop="actualctrlbirthday"
                            class="required"
                        >
                            <date-picker
                                :date="actualctrlBirthSet"
                                v-on:date-get="actualctrlDateBirth"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                        <el-form-item
                            label="控制人职业："
                            class="required"
                            prop="actualctrlvocation"
                        >
                            <el-select
                                v-model.trim="acctInfo.actualctrlvocation"
                                :disabled="!$util.getConfig().hideFunc"
                                filterable
                                :placeholder="$util.getConfig().hideFunc ? '请选择职业' : ''"
                            >
                                <el-option
                                    v-for="item in actualctrlvocation"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.actualisself === '0'" :span="24">
                        <el-form-item label="手机号码：" prop="actualctrltelno" class="required">
                            <!-- <el-select
                                v-model="acctInfo.actelnocycode"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请选择国家码' : ''"
                                style="width: 150px !important"
                            >
                                <el-option
                                    v-for="item in telcycode"
                                    :key="item.subitem"
                                    :label="item.subitemname + ' ' + item.subitem"
                                    :value="item.subitem"
                                />
                            </el-select>
                            <el-select
                                v-if="acctInfo.actelnocycode == '86'"
                                v-model="acctInfo.actelnoareacode"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请选择地区码' : ''"
                                style="width: 150px !important"
                                filterable
                                :filter-method="filterMethod"
                                v-on:focus="handleFilter"
                                v-on:change="handleFilter"
                            >
                                <el-option
                                    v-for="item in telareacode"
                                    :key="item.subitem"
                                    :label="item.subitemname + ' ' + item.subitem"
                                    :value="item.subitem"
                                >
                                    <div>
                                        {{ item.subitemname + " " + item.subitem }}
                                    </div>
                                </el-option>
                            </el-select>
                            <el-input
                                v-else
                                v-model.trim="acctInfo.actualctrltelnoareacodeinput"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请输入地区码' : ''"
                                style="width: 150px !important"
                            /> -->
                            <el-input
                                v-model.trim="acctInfo.actualctrltelno"
                                :disabled="!$util.getConfig().hideFunc"
                                style="margin-left: 2px; width: 300px"
                                :placeholder="
                                    $util.getConfig().hideFunc ? '请输入账户控制人的手机号码' : ''
                                "
                                :maxlength="11"
                                v-on:blur="changeInfoFn('actualctrltelno')"
                                v-on:focus="focusInfoFn('actualctrltelno')"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.actualisself === '0'" :span="24">
                        <country-city-select
                            ref="actualAddressObj"
                            v-model="actualAddressObj"
                            :hide-func="!$util.getConfig().hideFunc"
                            required
                            class="user-address"
                            country-layout="user"
                            v-on:input="getActualAdrss"
                        ></country-city-select>
                    </el-col>
                    <el-col v-if="acctInfo.actualisself === '0'" :span="24">
                        <el-form-item
                            label="通讯（现居）地址："
                            prop="actualctrladdr"
                            class="required"
                        >
                            <el-input
                                v-model.trim="acctInfo.actualctrladdr"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="
                                    $util.getConfig().hideFunc
                                        ? '请输入（现居）通讯地址（例如：xx省xx市xx区xx街道xx号）'
                                        : ''
                                "
                                :maxlength="32"
                                style="width: 87%"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                        <el-form-item label="电子邮箱：" prop="actualctrlemail" class="required">
                            <el-input
                                v-model.trim="acctInfo.actualctrlemail"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请输入电子邮箱' : ''"
                                :maxlength="32"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                        <el-form-item label="邮政编码：" prop="actualctrlpostcode" class="required">
                            <el-input
                                v-model.trim="acctInfo.actualctrlpostcode"
                                :disabled="!$util.getConfig().hideFunc"
                                :placeholder="$util.getConfig().hideFunc ? '请输入邮政编码' : ''"
                                :maxlength="6"
                            />
                        </el-form-item>
                    </el-col>
                    <!--<el-col v-if="acctInfo.actualisself==='0'" :span="12">
                    <el-form-item label="控制人与持有人关系：" prop="actualrelation" class="required">
                        <el-input v-model.trim="acctInfo.actualrelation" placeholder="请输入控制人与持有人关系" />
                    </el-form-item>
                </el-col>-->

                    <el-col v-if="isPwdCheck" :span="12">
                        <el-form-item label="交易密码：" prop="pwd" class="required">
                            <el-input
                                v-model.trim="acctInfo.pwd"
                                :disabled="!$util.getConfig().hideFunc"
                                type="password"
                                :placeholder="$util.getConfig().hideFunc ? '请输入交易密码' : ''"
                                :maxlength="16"
                            />
                            <span
                                class="redemp-btn"
                                v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                            >
                                <span class="like-a">忘记密码？</span>
                            </span>
                        </el-form-item>
                    </el-col>
                    <el-col class="btn-group">
                        <el-button class="cancel-btn" v-on:click="$router.back()">返回</el-button>
                        <el-button
                            v-if="$util.getConfig().hideFunc"
                            class="confirm-btn"
                            v-on:click.prevent="submitInfo('acctInfo')"
                        >
                            保存
                        </el-button>
                    </el-col>
                </el-form>
            </el-row>
            <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                width="50%"
                :close-on-click-modal="false"
            >
                <el-checkbox v-model="checked" class="check-style"></el-checkbox>
                <span>
                    本人承诺，以上所填信息发生重大变化时，本人将主动、及时进行信息更新，以便于贵机构重新评估本人风险承受能力。如本人未进行前述更新导致的投资损失以及其他法律后果由本人自行承担。
                </span>
                <span slot="footer" class="dialog-footer">
                    <el-button v-on:click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" :disabled="!checked" v-on:click="gotoSub()">
                        确 定
                    </el-button>
                </span>
            </el-dialog>
            <ocr-upd-dialog
                from="userInfo"
                :visible="ocrShow"
                :cert-type="acctInfo.certificatetype"
                v-on="{ success: imgUp, back: regression }"
            />
            <ocr-upd-dialog
                :visible="ocrShow2"
                :cert-type="acctInfo.benefitcertificatetype"
                check-flag="1"
                :skip-open-acct-check="true"
                v-on="{ success: imgUp2, back: regression2 }"
            />
            <ocr-upd-dialog
                :visible="ocrShow3"
                :cert-type="acctInfo.actualctrlcertype"
                check-flag="1"
                :skip-open-acct-check="true"
                v-on="{ success: imgUp3, back: regression3 }"
            />
        </div>
    </div>
</template>
<script>
import format from "date-fns/format";
import datePicker from "@/components/form/datePicker.vue";
import countryCitySelect from "@/components/acct/countryCitySelect.vue";
import userApi from "@/api/user";
import ocrUpdDialog from "@/components/form/ocrUpdDialog.vue";

export default {
    name: "UserInfo",
    components: {
        datePicker,
        countryCitySelect,
        ocrUpdDialog
    },
    props: {
        fn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            ocrShow: false,
            isPwdCheck: false,
            acctInfo: {
                pwd: "",
                telareacode: "",
                telnoareacodeinput: "",
                faxareacodeinput: "",
                benefittelnocycode: "86",
                benefittelnoareacode: "",
                beneficiarytelnoareacodeinput: "",
                actelnocycode: "86",
                actelnoareacode: "",
                actualctrltelnoareacodeinput: "",
                actualrelation: "",
                benefrelation: "",
                deliverway: [],
                // 代理人相关信息
                proxynationality: "CN",
                proxyname: "",
                proxycerno: "",
                proxycertype: "",
                proxyvaliddate: "",
                proxybirthday: "",
                proxysex: "",
                proxyduties: "",
                proxymobilecycode: "",
                proxymobileno: "",
                proxyaddress: "",
                proxyemail: "",
                proxypostcode: ""
            },
            livingAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null
                //                address:null,
            },
            // 数据字典
            certTypes: [],
            delivertype: [],
            sex: [],
            vocationcode: [],
            educationlevel: [],
            deliverways: [],
            nationality: [],
            province: [],
            specialpersonflag: [],
            isdigniaryorceo: [],
            faxareacode: [],
            // 受益人
            benefisself: [],
            benefitcertificatetype: [],
            benefitsex: [],
            benefitvocation: [],
            benefittelnocycode: [],
            benefittelnoareacode: [],
            benefAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null
                //                address:null,
            },
            // 控制人
            actualisself: [],
            actualctrltype: [],
            actualctrlsex: [],
            actualctrlvocation: [],
            telcycode: [],
            telareacode: [],
            telareacodeOld: [],
            actualAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null
                //                address:null,
            },
            // 日期配置
            dateSet: {
                type: "3",
                max: "",
                dis: !this.$util.getConfig().hideFunc
            },
            birthSet: {
                type: "1",
                min: "",
                dis: !this.$util.getConfig().hideFunc
            },
            beneficiaryDateSet: {
                type: "3",
                max: "",
                val: "",
                text: "请选择证件有效期",
                dis: !this.$util.getConfig().hideFunc
            },
            beneficiaryBirthSet: {
                type: "1",
                max: "",
                dis: !this.$util.getConfig().hideFunc,
                val: "",
                text: "请选择出生日期"
            },
            actualctrlDateSet: {
                type: "3",
                max: "",
                val: "",
                text: "请选择证件有效期",
                dis: !this.$util.getConfig().hideFunc
            },
            actualctrlBirthSet: {
                type: "1",
                max: "",
                dis: !this.$util.getConfig().hideFunc,
                val: "",
                text: "请选择出生日期"
            },
            beneficChangeFlag: true,
            actualctrlChangeFlag: true,
            isMobile: false, // 是否有手机号码
            isDelivertype: true, // 是否有delivertype的值，仅对fn=true起作用
            isBirthdate: true, // 是否有birthdate的值，仅对fn=true起作用
            isCertexpdate: true, // 是否有certexpdate的值，仅对fn=true起作用
            isBeneficiarydateflag: true,
            isactualctrlvalidateflag: true,
            dialogVisible: false,
            checked: false,
            rules: {
                mobileno: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur"
                    },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ],
                nationality: [
                    {
                        required: true,
                        message: "请选择国籍",
                        trigger: "change"
                    }
                ],
                /* province: [
                        { required: true, message: "请选择省份", trigger: "change" }
                    ], */
                birthday: [
                    {
                        required: true,
                        validator: this.$util.validateDate,
                        trigger: "blur"
                    }
                ],
                validdate: [
                    { validator: this.validateMin, trigger: "blur" },
                    { validator: this.$util.validateDate, trigger: "blur" }
                ],
                delivertype: [
                    {
                        required: true,
                        message: "请选对账单寄送周期",
                        trigger: "change"
                    }
                ],
                deliverway: [{ validator: this.validateDeliverway, trigger: "change" }],
                livingaddress: [
                    {
                        required: true,
                        validator: this.validateAddress,
                        trigger: "blur"
                    }
                ],
                postcode: [{ validator: this.validatePostCode, trigger: "blur" }],
                vocationsupple: [
                    {
                        required: true,
                        validator: this.validateVocationsupple,
                        trigger: "blur"
                    }
                ],
                educationlevel: [
                    {
                        required: true,
                        message: "请选择学历",
                        trigger: "change"
                    }
                ],
                vocationcode: [
                    {
                        required: true,
                        message: "请选择职业",
                        trigger: "change"
                    }
                ],
                email: [{ validator: this.validateDesEmail, trigger: "blur" }],
                telno: [{ validator: this.validateFax, trigger: "blur", validName: "telno" }],
                fax: [{ validator: this.validateFax, trigger: "blur", validName: "fax" }],
                benefisself: [
                    {
                        required: true,
                        message: "请选择受益人类型",
                        trigger: "change"
                    }
                ],
                benefitname: [{ validator: this.validateBeneficiary, trigger: "blur" }],
                benefitcertificatetype: [
                    {
                        validator: this.validateBeneficiarytype,
                        trigger: "change"
                    }
                ],
                benefitcertificateno: [{ validator: this.validateBeneficiaryno, trigger: "blur" }],
                benefitbirthday: [
                    {
                        required: true,
                        validator: this.$util.validateDate,
                        trigger: "blur"
                    }
                ],
                benefitvaliddate: [
                    { validator: this.validateMin, trigger: "blur" },
                    { validator: this.$util.validateDate, trigger: "blur" }
                ],
                benefitsex: [
                    {
                        required: true,
                        message: "请选择性别",
                        trigger: "change"
                    }
                ],
                benefitvocation: [
                    {
                        required: true,
                        message: "请选择职业",
                        trigger: "change"
                    }
                ],
                benefitemail: [{ validator: this.$util.validateEmail, trigger: "blur" }],
                benefitpostcode: [{ validator: this.$util.validatePostCode, trigger: "blur" }],
                benefitaddress: [
                    {
                        required: true,
                        validator: this.validateAddress,
                        trigger: "blur"
                    }
                ],
                actualisself: [
                    {
                        required: true,
                        message: "请选择控制人类型",
                        trigger: "change"
                    }
                ],
                actualctrlname: [{ validator: this.validateActualctrlname, trigger: "blur" }],
                actualctrlsex: [
                    {
                        required: true,
                        message: "请选择性别",
                        trigger: "change"
                    }
                ],
                actualctrlcertype: [
                    {
                        validator: this.validateActualctrlidtype,
                        trigger: "change"
                    }
                ],
                actualctrlcerno: [{ validator: this.validateActualctrl, trigger: "blur" }],
                actualctrlbirthday: [
                    {
                        required: true,
                        validator: this.$util.validateDate,
                        trigger: "blur"
                    }
                ],
                actualctrlvalidate: [
                    { validator: this.validateMin, trigger: "blur" },
                    { validator: this.$util.validateDate, trigger: "blur" }
                ],
                actualctrlvocation: [
                    {
                        required: true,
                        message: "请选择职业",
                        trigger: "change"
                    }
                ],
                actualctrlpostcode: [{ validator: this.validatePostCode2, trigger: "blur" }],
                actualctrlemail: [{ validator: this.validateEmail, trigger: "blur" }],
                assetssource: [{ validator: this.validateAssetssource, trigger: "blur" }],
                /* actualrelation: [
                        { required: true, message: "请输入控制人与持有人关系", trigger: "blur" }
                    ], */
                benefittelno: [
                    { required: true, message: "请输入账户受益人的手机号码", trigger: "blur" },
                    {
                        validator: this.validateMobile,
                        trigger: "blur",
                        validName: "benefittelno"
                    }
                ],
                actualctrltelno: [
                    { required: true, message: "请输入账户控制人的手机号码", trigger: "blur" },
                    {
                        validator: this.validateMobile,
                        trigger: "blur",
                        validName: "actualctrltelno"
                    }
                ],
                actualctrladdr: [
                    {
                        required: true,
                        validator: this.validateAddress,
                        trigger: "blur"
                    }
                ],
                pwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ],
                annualincome: [{ required: true, message: "请输入年收入", trigger: "blur" }],
                specialpersonflag: [
                    {
                        required: true,
                        message: "请选择特定自然人标识",
                        trigger: "change"
                    }
                ],
                isdigniaryorceo: [
                    {
                        required: true,
                        message: "请选择受益人类型",
                        trigger: "change"
                    }
                ],
                /* benefrelation: [
                        { required: true, message: "请输入受益人与持有人关系", trigger: "blur" }
                    ] */
                proxyname: [{ validator: this.checkProxyName, trigger: "blur" }],
                proxycertype: [{ validator: this.checkProxyType, trigger: "change" }],
                proxycerno: [{ validator: this.checkProxyCertNo, trigger: "blur" }],
                proxyvaliddate: [{ validator: this.checkProxyVailddate, trigger: "blur" }],
                proxybirthday: [
                    { validator: this.checkProxyBirthdate, trigger: "blur" },
                    { validator: this.checkProxyBirthdate, trigger: "change" }
                ],
                proxysex: [
                    {
                        required: true,
                        message: "请选择性别",
                        trigger: "change"
                    }
                ],
                proxyduties: [
                    {
                        required: true,
                        message: "请选择职业",
                        trigger: "change"
                    }
                ],
                proxymobileno: [
                    { validator: this.validateFax, trigger: "blur", validName: "actualctrltelno" }
                ],
                proxyaddress: [
                    {
                        required: true,
                        validator: this.validateAddress,
                        trigger: "blur"
                    }
                ],
                proxyemail: [{ validator: this.validateEmail, trigger: "blur" }],
                proxypostcode: [{ validator: this.validatePostCode, trigger: "blur" }]
            },
            ocrOnOff: false,
            hasOcr: "0",
            ocrStatus: false,
            ocrBtnInfo: "更新证件信息",
            ocrUploadFlag: "",
            benefitSexDis: false,
            actualSexDis: false,
            proxyvaliddate: {
                type: "3",
                max: "",
                dis: false,
                val: "",
                text: "请选择证件有效期"
            },
            proxyDateSetBirth: {
                type: "1",
                max: "",
                dis: false,
                val: "",
                text: "请选择出生日期"
            },
            proxySexDis: false,
            proxyduties: [],
            proxymobilecycode: [],
            // 受益人和控制人orc相关的
            ocrUpdBtnS: false,
            dis: false,
            ocrUpdBtnS2: false,
            ocrShow2: false,
            dis2: false,
            ocrShow3: false,
            ocrBtnText: "上传证件照",
            loading: true
        };
    },
    computed: {
        ocrDis: function () {
            return !(this.acctInfo.benefitcertificatetype == "00");
        },
        ocrDis2: function () {
            return !(this.acctInfo.actualctrlcertype == "00");
        }
    },
    watch: {
        "acctInfo.benefitcertificatetype"(val) {
            if (val === "00") {
                this.beneficiaryBirthSet.dis = true;
                this.ocrUpdBtnS = this.ocrOnOff;
                this.beneficiaryDateSet.dis = this.ocrOnOff;
                if (!this.loading) {
                    this.acctInfo.benefitname = "";
                    this.acctInfo.benefitcertificateno = "";
                    this.acctInfo.benefitsex = "";
                    this.acctInfo.benefitvaliddate = "";
                    this.acctInfo.benefitbirthday = "";
                    this.$set(this.beneficiaryDateSet, "val", "");
                    this.$set(this.beneficiaryBirthSet, "val", "");
                    setTimeout(() => {
                        this.$refs.acctInfo.clearValidate([
                            "benefitname",
                            "benefitcertificateno",
                            "benefitsex",
                            "benefitvaliddate",
                            "benefitbirthday"
                        ]);
                    }, 1000);
                }
            } else if (val === "0B") {
                if (this.getSex(this.$cache.getUser().benefitcertificateno)) {
                    this.acctInfo.benefitcertificateno = this.$cache.getUser().benefitcertificateno;
                }
                this.ocrUpdBtnS = false;
                this.beneficiaryDateSet.dis = false;
            } else {
                // this.beneficiaryBirthSet.dis = false;
                if (
                    this.$cache.getUser().benefitcertificatetype ==
                    this.acctInfo.benefitcertificatetype
                ) {
                    this.acctInfo.benefitcertificateno = this.$cache.getUser().benefitcertificateno;
                } else {
                    this.acctInfo.benefitcertificateno = "";
                }
                this.ocrUpdBtnS = false;
                this.beneficiaryDateSet.dis = false;
            }
        },
        "acctInfo.actualctrlcertype"(val) {
            if (val === "00") {
                this.actualctrlBirthSet.dis = true;
                this.ocrUpdBtnS2 = this.ocrOnOff;
                this.actualctrlDateSet.dis = this.ocrOnOff;
                if (!this.loading) {
                    this.acctInfo.actualctrlname = "";
                    this.acctInfo.actualctrlcerno = "";
                    this.acctInfo.actualctrlsex = "";
                    this.acctInfo.actualctrlvalidate = "";
                    this.acctInfo.actualctrlbirthday = "";
                    this.$set(this.actualctrlDateSet, "val", "");
                    this.$set(this.actualctrlBirthSet, "val", "");
                    setTimeout(() => {
                        this.$refs.acctInfo.clearValidate([
                            "actualctrlname",
                            "actualctrlcerno",
                            "actualctrlsex",
                            "actualctrlvalidate",
                            "actualctrlbirthday"
                        ]);
                    }, 1000);
                }
            } else if (val === "0B") {
                if (this.getSex(this.$cache.getUser().actualctrlcerno)) {
                    this.acctInfo.actualctrlcerno = this.$cache.getUser().actualctrlcerno;
                }
                this.ocrUpdBtnS2 = false;
                this.actualctrlDateSet.dis = false;
            } else {
                // this.actualctrlBirthSet.dis = false;
                if (this.$cache.getUser().actualctrlcertype == this.acctInfo.actualctrlcertype) {
                    this.acctInfo.actualctrlcerno = this.$cache.getUser().actualctrlcerno;
                } else {
                    this.acctInfo.actualctrlcerno = "";
                }
                this.ocrUpdBtnS2 = false;
                this.actualctrlDateSet.dis = false;
            }
        },
        "acctInfo.delivertype"(val) {
            if (val === "1") {
                this.acctInfo.deliverway = [];
            }
        },
        "acctInfo.vocationcode"(val) {
            if (val !== "14" && val === "29") {
                this.acctInfo.vocationsupple = "";
            }
        },
        "acctInfo.benefisself"(val) {
            if (this.beneficChangeFlag) {
                this.beneficChangeFlag = !this.beneficChangeFlag;
                return false;
            }
            this.acctInfo.benefitname = "";
            this.acctInfo.benefitcertificatetype = "";
            this.acctInfo.benefitcertificateno = "";
            this.acctInfo.benefitvaliddate = "";
            this.acctInfo.benefitsex = "";
            this.acctInfo.benefitbirthday = "";
            this.acctInfo.benefitvocation = "";
            this.acctInfo.benefittelnocycode = "";
            this.acctInfo.benefittelnoareacode = "";
            this.acctInfo.beneficiarytelnoareacodeinput = "";
            this.acctInfo.benefittelno = "";
            this.acctInfo.benefitcountry = "";
            this.acctInfo.benefitaddressprovince = "";
            this.acctInfo.benefitaddresscity = "";
            this.acctInfo.benefitaddresscounty = "";
            this.acctInfo.benefitaddress = "";
            this.acctInfo.benefitemail = "";
            this.acctInfo.benefitpostcode = "";
            this.acctInfo.benefrelation = "";
            this.$set(this.beneficiaryDateSet, "val", "");
            this.$set(this.beneficiaryBirthSet, "val", "");
            this.$set(this.beneficiaryDateSet, "time", new Date().getTime());
            this.$set(this.beneficiaryBirthSet, "time", new Date().getTime());
            this.benefAddressObj = {
                country: "CN",
                province: null,
                city: null,
                county: null
            };
        },
        "acctInfo.actualisself"(val) {
            if (this.actualctrlChangeFlag) {
                this.actualctrlChangeFlag = !this.actualctrlChangeFlag;
                return false;
            }
            this.acctInfo.actualctrl = "";
            this.acctInfo.actualctrlname = "";
            this.acctInfo.actualctrltype = "";
            this.acctInfo.actualctrlno = "";
            this.acctInfo.actualctrldate = "";
            this.acctInfo.actualctrlsex = "";
            this.acctInfo.actualctrlbirthday = "";
            this.acctInfo.actualctrlvocation = "";
            this.acctInfo.actelnocycode = "";
            this.acctInfo.actelnoareacode = "";
            this.acctInfo.actualctrltelnoareacodeinput = "";
            this.acctInfo.actualctrltelno = "";
            this.acctInfo.actualctrlcountry = "";
            this.acctInfo.actualctrladdrprovince = "";
            this.acctInfo.actualctrladdrcity = "";
            this.acctInfo.actualctrladdrcounty = "";
            this.acctInfo.actualctrladdr = "";
            this.acctInfo.actualctrlemail = "";
            this.acctInfo.actualctrlpostcode = "";
            this.acctInfo.actualrelation = "";
            this.acctInfo.actualctrlvalidate = "";
            this.acctInfo.actualctrlcerno = "";
            this.acctInfo.actualctrlcertype = "";
            this.$set(this.actualctrlDateSet, "val", "");
            this.$set(this.actualctrlBirthSet, "val", "");
            this.$set(this.actualctrlDateSet, "time", new Date().getTime());
            this.$set(this.actualctrlBirthSet, "time", new Date().getTime());
            this.actualAddressObj = {
                country: "CN",
                province: null,
                city: null,
                county: null
            };
        },
        "acctInfo.telcycode"(val) {
            if (val != "86") {
                this.acctInfo.telnoareacodeinput = this.acctInfo.telareacode;
            }
        },
        "acctInfo.telnoareacodeinput"(val) {
            this.acctInfo.telareacode = this.acctInfo.telnoareacodeinput;
        },
        "acctInfo.faxcycode"(val) {
            if (val != "86") {
                this.acctInfo.faxareacodeinput = this.acctInfo.faxareacode;
            }
        },
        "acctInfo.faxareacodeinput"(val) {
            this.acctInfo.faxareacode = this.acctInfo.faxareacodeinput;
        },
        "acctInfo.benefittelnocycode"(val) {
            if (val != "86") {
                this.acctInfo.beneficiarytelnoareacodeinput = this.acctInfo.benefittelnoareacode;
            }
        },
        "acctInfo.beneficiarytelnoareacodeinput"(val) {
            this.acctInfo.benefittelnoareacode = this.acctInfo.beneficiarytelnoareacodeinput;
        },
        "acctInfo.actelnocycode"(val) {
            if (val != "86") {
                this.acctInfo.actualctrltelnoareacodeinput = this.acctInfo.actelnoareacode;
            }
        },
        "acctInfo.actualctrltelnoareacodeinput"(val) {
            this.acctInfo.actelnoareacode = this.acctInfo.actualctrltelnoareacodeinput;
        }
    },
    created() {
        const birthmax = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
        // this.hasOcr = this.$cache.getParams("hasocr");
        this.birthSet.max = this.$util.fmtDate(birthmax);
        this.birthSet.min = this.$util.fmtDate("19000101");
        // 重新提取最小日期
        const conf = this.$util.getConfig().const;
        const info = this.$cache.getUser();
        this.beneficiaryDateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.beneficiaryBirthSet.max = this.$util.fmtDate(birthmax);
        this.beneficiaryBirthSet.min = this.$util.fmtDate("19000101");
        this.$set(this.beneficiaryDateSet, "val", format(info.benefitvaliddate, "YYYY-MM-DD"));
        this.$set(this.beneficiaryDateSet, "time", new Date().getTime());
        this.$set(this.beneficiaryBirthSet, "val", format(info.benefitbirthday, "YYYY-MM-DD"));
        this.$set(this.beneficiaryBirthSet, "time", new Date().getTime());
        this.actualctrlDateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.actualctrlBirthSet.max = this.$util.fmtDate(birthmax);
        this.actualctrlBirthSet.min = this.$util.fmtDate(conf.BIRTH_DATE);
        this.$set(this.actualctrlDateSet, "val", format(info.actualctrlvalidate, "YYYY-MM-DD"));
        this.$set(this.actualctrlDateSet, "time", new Date().getTime());
        this.$set(this.actualctrlBirthSet, "val", format(info.actualctrlbirthday, "YYYY-MM-DD"));
        this.$set(this.actualctrlBirthSet, "time", new Date().getTime());
        this.proxyvaliddate.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.proxyDateSetBirth.max = this.$util.fmtDate(birthmax);
        this.proxyDateSetBirth.min = this.$util.fmtDate("19000101");
        this.$set(this.proxyDateSetBirth, "val", format(info.proxybirthday, "YYYY-MM-DD"));
        this.$set(this.proxyDateSetBirth, "time", new Date().getTime());
        this.proxyvaliddate.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.$set(this.proxyvaliddate, "val", format(info.proxyvaliddate, "YYYY-MM-DD"));
        this.$set(this.proxyvaliddate, "time", new Date().getTime());
        // 修改用户信息接口不支持校验交易密码
        // this.isPwdCheck = this.$cache.getPwdCheck("B1");
        const _x = {};
        for (let item in info) {
            _x[item] = info[item] ? (info[item] + "").trim() : "";
        }
        if (!_x.delivertype) {
            this.isDelivertype = false;
        }
        if (!_x.birthday) {
            this.isBirthdate = false;
        }
        if (!_x.validdate || _x.certexpired === "1" || !this.$util.isEmpty(_x.daystoexpired)) {
            this.isCertexpdate = false;
        }
        if (_x.benefexpdate === "1") {
            this.isBeneficiarydateflag = false;
        }
        if (_x.actualctrlexp === "1") {
            this.isactualctrlvalidateflag = false;
        }
        if (_x.mobileno) {
            this.isMobile = true;
        }
        // 国籍默认中国
        if (!_x.nationality) {
            _x.nationality = "CN";
        }
        if (this.$route.query) {
            _x.custname = this.$route.query.custname || _x.custname;
            _x.certificateno = this.$route.query.certificateno || _x.certificateno;
            _x.validdate = this.$route.query.vailddate || _x.validdate;
            _x.birthday = this.$route.query.birthdate || _x.birthday;
            if (_x.certTypeText === "身份证" && this.$route.query.certificateno) {
                _x.sex = (this.$route.query.certificateno.substr(16, 1) % 2).toString();
            }
            if (
                _x.benefitcertificatetype === "身份证" &&
                this.$route.query.beneficiaryno &&
                _x.benefisself === "1"
            ) {
                _x.benefitsex = (this.$route.query.beneficiaryno.substr(16, 1) % 2).toString();
            }
            if (
                _x.actualctrlcertype === "身份证" &&
                this.$route.query.actualctrlidcode &&
                _x.actualisself === "1"
            ) {
                _x.actualctrlsex = (
                    this.$route.query.actualctrlidcode.substr(16, 1) % 2
                ).toString();
            }
            // const _this = this;
            // if (this.$route.query.birthdate) {
            //     const _date = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
            //     if (this.$cache.getCompanyInfoParam("100047") == "0") {
            //         if (Number(this.$route.query.birthdate) >= Number(_date)) {
            //             _this
            //                 .$alert("根据您的证件信息，您属于未成年人，暂时无法开户！", "", {
            //                     confirmButtonText: "确定",
            //                     type: "warning",
            //                     callback: (action) => {
            //                         _this.$router.push({ name: "acctManager" });
            //                     }
            //                 })
            //                 .then(() => {
            //                     return false;
            //                 })
            //                 .catch(() => {
            //                     return false;
            //                 });
            //         }
            //     }
            // }
        }
        _x.deliverway = _x.deliverway && _x.deliverway.split(",");
        if (!_x.proxyname || _x.proxyname == "") {
            this.acctInfo.proxyaddress = "";
            this.acctInfo.proxybirthday = "";
            this.acctInfo.proxycerno = "";
            this.acctInfo.proxycertype = "";
            this.acctInfo.proxyduties = "";
            this.acctInfo.proxyemail = "";
            this.acctInfo.proxymobilecycode = "";
            this.acctInfo.proxymobileno = "";
            this.acctInfo.proxyname = "";
            this.acctInfo.proxypostcode = "";
            this.acctInfo.proxysex = "";
            this.acctInfo.proxyvaliddate = "";
            this.acctInfo.proxyvaliddatetype = "";
        }
        this.acctInfo = Object.assign({}, this.acctInfo, _x);
        this.mobileBind(this.acctInfo);
        this.dateSet.val = this.acctInfo.validdate
            ? this.$util.fmtDate(this.acctInfo.validdate)
            : "";
        if (
            this.acctInfo.validtype == "1" ||
            this.acctInfo.validdate == "长期有效" ||
            this.acctInfo.validdate == "99991231"
        ) {
            this.acctInfo.validtype = "1";
            this.acctInfo.validdate = "99991231";
            this.dateSet.val = "9999-12-31";
        }
        if (
            this.acctInfo.actualctrlvalitype == "1" ||
            this.acctInfo.actualctrlvalidate == "长期有效" ||
            this.acctInfo.actualctrlvalidate == "99991231"
        ) {
            this.acctInfo.actualctrlvalitype = "1";
            this.acctInfo.actualctrlvalidate = "99991231";
            this.actualctrlDateSet.val = "9999-12-31";
        }
        if (
            this.acctInfo.benefitvalidtype == "1" ||
            this.acctInfo.benefitvaliddate == "长期有效" ||
            this.acctInfo.benefitvaliddate == "99991231"
        ) {
            this.acctInfo.benefitvalidtype = "1";
            this.acctInfo.benefitvaliddate = "99991231";
            this.beneficiaryDateSet.val = "9999-12-31";
        }
        if (
            this.acctInfo.proxyvaliddatetype == "1" ||
            this.acctInfo.proxyvaliddate == "长期有效" ||
            this.acctInfo.proxyvaliddate == "99991231"
        ) {
            this.acctInfo.proxyvaliddatetype = "1";
            this.acctInfo.proxyvaliddate = "99991231";
            this.proxyvaliddate.val = "9999-12-31";
        }
        this.dateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.birthSet.min = this.$util.fmtDate(conf.BIRTH_DATE);
        // :TODO: 测试瑞年
        this.birthSet.max = this.$util.fmtDate(format(new Date(), "YYYYMMDD") - 180000);

        this.certTypes = this.$cache.getDict("130007");
        this.delivertype = this.$cache.getDict("110046");
        this.sex = this.$cache.getDict("110059").reverse();
        this.benefitsex = this.$cache.getDict("110059").reverse();
        this.actualctrlsex = this.$cache.getDict("110059").reverse();
        this.vocationcode = this.$cache.getDict("150141");
        this.deliverways = this.$cache.getDict("100013");
        this.educationlevel = this.$cache.getDict("20011");
        this.specialpersonflag = this.$cache.getDict("120200"); // 特定自然人标识
        this.isdigniaryorceo = this.$cache.getDict("120200");
        this.nationality = this.$util.changeArrIndex(this.$cache.getDict("120109"), "CN");
        this.province = this.$cache.getDict("120122");
        // 代理人
        this.proxyduties = this.$cache.getDict("150141");
        this.proxymobilecycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        // 受益人
        this.benefitvocation = this.$cache.getDict("150141");
        // this.benefittelnocycode = this.$cache.getDict("150136"); //国家码
        this.benefittelnocycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.benefittelnoareacode = this.$cache.getDict("150137");
        // 控制人
        this.actualctrlvocation = this.$cache.getDict("150141");
        // this.telcycode = this.$cache.getDict("150136"); //国家码
        this.telcycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.telareacode = this.$cache.getDict("150137");
        this.telareacodeOld = this.$cache.getDict("150137");
        this.benefisself = [...this.$cache.getDict("120137")].reverse();
        this.benefitcertificatetype = this.$cache.getDict("130007");
        this.actualisself = [...this.$cache.getDict("120137")].reverse();
        this.actualctrlcertype = this.$cache.getDict("130007");
        this.getOcrOpenStatus();
        this.initAddress();
        this.initBenefAddress();
        this.initActualAddress();
        this.changeBenefitTypeFn();
        this.changeActualctrlTypeFn();
        this.changeSelfValidateFn();
        this.changeProxyTypeFn();
    },
    mounted() {
        setTimeout(() => {
            this.loading = false;
        }, 3000);
        // 根据配置参数限制字典选项（通用处理）
        this.applyDictLimitConfig();
    },
    methods: {
        filterMethod(query) {
            this.telareacode = this.telareacodeOld.filter((item) => {
                if ((item.subitemname + item.subitem).indexOf(query) > -1) {
                    return item;
                }
            });
        },
        handleFilter() {
            this.telareacode = this.telareacodeOld;
        },
        imgUp(flag) {
            if (flag) {
                // flag.certificateno = "962036201304300452"; // 临时代码
                // flag.vailddate = "20300101";
                this.acctInfo.certificateno = flag.certificateno;
                this.acctInfo.sex = flag.sex;
                this.acctInfo.validdate = flag.vailddate;
            }
            this.dateSet = Object.assign({}, this.dateSet);
            this.dateSet.val = this.$util.fmtDate(this.acctInfo.validdate);
            this.initBirthdate(); /* 从证件号截取 */
        },
        regression() {
            this.ocrShow = false;
        },
        initBirthdate() {
            // 身份证
            if (
                this.acctInfo.certificatetype === "00" ||
                this.acctInfo.certificatetype === "05" ||
                this.acctInfo.certificatetype === "0B"
            ) {
                const sIdNo = this.acctInfo.certificateno;
                const that = this;
                that.$util.validateCertNo(
                    "",
                    sIdNo,
                    function () {
                        that.$set(
                            that.birthSet,
                            "val",
                            that.$util.fmtDate(
                                that.$util.getBirthdate(sIdNo, this.acctInfo.certificatetype),
                                "-"
                            )
                        );
                    },
                    this.acctInfo.certificatetype
                );
            }
        },
        imgUp2(flag) {
            this.beneficiaryBirthSet.dis = true;
            this.beneficiaryDateSet.dis = true;
            if (flag) {
                this.acctInfo.benefitcertificateno = flag.certificateno;
                this.acctInfo.benefitname = flag.custname;
            }
            this.acctInfo.benefitsex = this.getSex(this.acctInfo.benefitcertificateno);
            this.beneficiaryDateSet.val = this.$util.fmtDate(flag.vailddate);
            this.acctInfo.benefitvaliddate =
                this.beneficiaryDateSet.val != ""
                    ? this.beneficiaryDateSet.val.replace(/-/g, "")
                    : "";
            // 长期有效的勾选框渲染
            this.$nextTick(() => {
                if (this.beneficiaryDateSet.val == "9999-12-31") {
                    this.$refs.beneficiaryDateSet.checked = true;
                    this.$refs.beneficiaryDateSet.dateChange();
                }
            });
            this.initBirthdate2(); /* 从证件号截取 */
            setTimeout(() => {
                this.$refs.acctInfo.clearValidate([
                    "benefitname",
                    "benefitcertificateno",
                    "benefitsex",
                    "benefitvaliddate",
                    "benefitbirthday"
                ]);
            }, 1000);
        },
        initBirthdate2() {
            // 身份证
            if (this.acctInfo.benefitcertificatetype === "00") {
                const sIdNo = this.acctInfo.benefitcertificateno;
                const that = this;
                that.acctInfo.benefitbirthday = that.$util.getBirthdate(
                    sIdNo,
                    that.acctInfo.benefitcertificatetype
                );
                that.$set(
                    that.beneficiaryBirthSet,
                    "val",
                    that.$util.fmtDate(that.acctInfo.benefitbirthday, "-")
                );
            }
        },
        regression2() {
            this.ocrShow2 = false;
        },
        imgUp3(flag) {
            this.actualctrlBirthSet.dis = true;
            this.actualctrlDateSet.dis = true;
            if (flag) {
                this.acctInfo.actualctrlcerno = flag.certificateno;
                this.acctInfo.actualctrlname = flag.custname;
            }
            this.acctInfo.actualctrlsex = this.getSex(this.acctInfo.actualctrlcerno);
            this.actualctrlDateSet.val = this.$util.fmtDate(flag.vailddate);
            this.acctInfo.actualctrlvalidate =
                this.actualctrlDateSet.val != ""
                    ? this.actualctrlDateSet.val.replace(/-/g, "")
                    : "";
            // 长期有效的勾选框渲染
            this.$nextTick(() => {
                if (this.actualctrlDateSet.val == "9999-12-31") {
                    this.$refs.actualctrlDateSet.checked = true;
                    this.$refs.actualctrlDateSet.dateChange();
                }
            });
            this.initBirthdate3(); /* 从证件号截取 */
            setTimeout(() => {
                this.$refs.acctInfo.clearValidate([
                    "actualctrlname",
                    "actualctrlcerno",
                    "actualctrlsex",
                    "actualctrlvalidate",
                    "actualctrlbirthday"
                ]);
            }, 1000);
        },
        initBirthdate3() {
            // 身份证
            if (this.acctInfo.actualctrlcertype === "00") {
                const sIdNo = this.acctInfo.actualctrlcerno;
                const that = this;
                that.acctInfo.actualctrlbirthday = that.$util.getBirthdate(
                    sIdNo,
                    that.acctInfo.actualctrlcertype
                );
                that.$set(
                    that.actualctrlBirthSet,
                    "val",
                    that.$util.fmtDate(that.acctInfo.actualctrlbirthday, "-")
                );
            }
        },
        regression3() {
            this.ocrShow3 = false;
        },
        initAddress() {
            this.livingAddressObj["country"] = this.acctInfo["livingcountry"];
            this.livingAddressObj["province"] = this.acctInfo["livingaddressprovince"];
            this.livingAddressObj["city"] = this.acctInfo["livingaddresscity"];
            this.livingAddressObj["county"] = this.acctInfo["livingaddresscounty"];
        },
        getAdrss(data) {
            // this.acctInfo.address = data.address;
            // this.acctInfo.livingaddress = data.address;
            if (data.country !== "CN") {
                this.livingAddressObj["province"] = "";
                this.livingAddressObj["city"] = "";
                this.livingAddressObj["county"] = "";
            }
        },
        // 受益人国家、省、市、县
        initBenefAddress() {
            this.benefAddressObj["country"] = this.acctInfo["benefitcountry"];
            this.benefAddressObj["province"] = this.acctInfo["benefitaddressprovince"];
            this.benefAddressObj["city"] = this.acctInfo["benefitaddresscity"];
            this.benefAddressObj["county"] = this.acctInfo["benefitaddresscounty"];
        },
        getBenefAdrss(data) {
            // this.acctInfo.benefitaddress = data.address;
            if (data.country !== "CN") {
                this.benefAddressObj["province"] = "";
                this.benefAddressObj["city"] = "";
                this.benefAddressObj["county"] = "";
            }
        },
        // 控制人国家、省、市、县
        initActualAddress() {
            this.actualAddressObj["country"] = this.acctInfo["actualctrlcountry"];
            this.actualAddressObj["province"] = this.acctInfo["actualctrladdrprovince"];
            this.actualAddressObj["city"] = this.acctInfo["actualctrladdrcity"];
            this.actualAddressObj["county"] = this.acctInfo["actualctrladdrcounty"];
        },
        setAddress() {
            this.acctInfo["livingcountry"] = this.livingAddressObj["country"];
            this.acctInfo["livingaddressprovince"] = this.livingAddressObj["province"];
            this.acctInfo["livingaddresscity"] = this.livingAddressObj["city"];
            this.acctInfo["livingaddresscounty"] = this.livingAddressObj["county"];

            this.acctInfo["benefitcountry"] =
                this.acctInfo["benefisself"] == "0" ? this.benefAddressObj["country"] : "";
            this.acctInfo["benefitaddressprovince"] =
                this.acctInfo["benefisself"] == "0" ? this.benefAddressObj["province"] : "";
            this.acctInfo["benefitaddresscity"] =
                this.acctInfo["benefisself"] == "0" ? this.benefAddressObj["city"] : "";
            this.acctInfo["benefitaddresscounty"] =
                this.acctInfo["benefisself"] == "0" ? this.benefAddressObj["county"] : "";

            this.acctInfo["actualctrlcountry"] =
                this.acctInfo["actualisself"] == "0" ? this.actualAddressObj["country"] : "";
            this.acctInfo["actualctrladdrprovince"] =
                this.acctInfo["actualisself"] == "0" ? this.actualAddressObj["province"] : "";
            this.acctInfo["actualctrladdrcity"] =
                this.acctInfo["actualisself"] == "0" ? this.actualAddressObj["city"] : "";
            this.acctInfo["actualctrladdrcounty"] =
                this.acctInfo["actualisself"] == "0" ? this.actualAddressObj["county"] : "";
        },
        getActualAdrss(data) {
            // this.acctInfo.actualctrladdr = data.address;
            if (data.country !== "CN") {
                this.actualAddressObj["province"] = "";
                this.actualAddressObj["city"] = "";
                this.actualAddressObj["county"] = "";
            }
        },
        checkAddressInfo() {
            let hasLivingAddrInfo = true;
            if (this.acctInfo.livingcountry === this.$const.CN) {
                hasLivingAddrInfo =
                    !!this.acctInfo.livingaddressprovince &&
                    !!this.acctInfo.livingaddress &&
                    !!this.acctInfo.livingaddresscity;
            } else {
                hasLivingAddrInfo = !!this.acctInfo.livingaddress;
            }
            if (!hasLivingAddrInfo) {
                this.$alert("请完善现居地址(国家/地区-省-市-县)信息！", "提示");
                return false;
            }
            return true;
        },
        checkBenefActualInfo() {
            let hasBenefInfo = true;
            let hasCtrlInfo = true;
            if (this.acctInfo.benefisself === "0") {
                let excludeitems = ["county"]; // 有些地方没有县
                if (this.acctInfo.benefitcountry !== this.$const.CN) {
                    excludeitems = excludeitems.concat(["province", "city", "county"]);
                }
                this.benefAddressObj.address = this.acctInfo.benefitaddress;
                hasBenefInfo = this.$util.checkInfoFilled(this.benefAddressObj, excludeitems);
            }
            if (this.acctInfo.actualisself === "0") {
                let excludeitems = ["county", "actualAddressObj"]; // 有些地方没有县
                if (this.acctInfo.actualctrlcountry !== this.$const.CN) {
                    excludeitems = excludeitems.concat(["province", "city", "county"]);
                }
                this.actualAddressObj.address = this.acctInfo.actualctrladdr;
                hasCtrlInfo = this.$util.checkInfoFilled(this.actualAddressObj, excludeitems);
            }

            if (!hasCtrlInfo) {
                this.$alert("请完善实际控制人地址(国家/地区-省-市-县)信息！", "提示");
                return false;
            }
            if (!hasBenefInfo) {
                this.$alert("请完善实际受益人地址(国家/地区-省-市-县)信息！", "提示");
                return false;
            }
            return true;
        },
        mobileBind(info) {
            if (info.mobileno.length != 11 && info.needfillcustinfo == "0") {
                this.$alert("您暂未绑定手机号，请前往绑定！", "手机号绑定", {
                    confirmButttonText: "前往",
                    showCancelButton: false,
                    type: "warning",
                    callback: (action) => {
                        this.$router.push({ name: "bindmobile" });
                    }
                }).then((res) => {});
            }
        },
        dateInterval(val) {
            this.acctInfo.validdate = !this.$util.isEmpty(val) ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("validdate");
        },
        dateBirth(val) {
            this.acctInfo.birthday = !this.$util.isEmpty(val) ? val.replace(/-/g, "") : "";
        },
        proxyDateInterval(val) {
            this.acctInfo.proxyvaliddate = !this.$util.isEmpty(val) ? val.replace(/-/g, "") : "";
            this.proxyvaliddate.val =
                this.acctInfo.proxyvaliddate != ""
                    ? this.$util.fmtDate(this.acctInfo.proxyvaliddate, "-")
                    : "";
            this.$refs.acctInfo.validateField("proxyvaliddate");
        },
        proxyDateInterval_birth(val) {
            this.acctInfo.proxybirthday = !this.$util.isEmpty(val) ? val.replace(/-/g, "") : "";
        },
        // 受益人出生日期
        beneficiaryDateBirth(val) {
            this.acctInfo.benefitbirthday = !this.$util.isEmpty(val) ? val.replace(/-/g, "") : "";
        },
        // 受益人证件有效期
        beneficiaryDateInterval(val) {
            this.acctInfo.benefitvaliddate = !this.$util.isEmpty(val) ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("benefitvaliddate");
        },
        // 控制人出生日期
        actualctrlDateBirth(val) {
            this.acctInfo.actualctrlbirthday = !this.$util.isEmpty(val)
                ? val.replace(/-/g, "")
                : "";
        },
        // 控制人证件有效期
        actualctrlDateInterval(val) {
            this.acctInfo.actualctrlvalidate = !this.$util.isEmpty(val)
                ? val.replace(/-/g, "")
                : "";
            this.$refs.acctInfo.validateField("actualctrlvalidate");
        },
        validateAddress(rule, value, callback) {
            /* if (this.acctInfo.deliverway === "1" && !value) { */
            if (!value) {
                callback(new Error("请输入详细地址"));
                return;
            }
            let len = 0;
            for (let i = 0; i < value.length; i++) {
                if (value.charCodeAt(i) > 127 || value.charCodeAt(i) === 94) {
                    len += 2;
                } else {
                    len++;
                }
            }
            if (len < 12) {
                callback(new Error("详细地址不小于6个汉字或12个字符！"));
            } else {
                callback();
            }
        },
        validateLocation(rule, value, callback) {
            if (this.acctInfo.nationality === "CN") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择省份"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateAssetssource(rule, value, callback) {
            if (
                this.acctInfo.specialpersonflag === "1" ||
                this.acctInfo.specialpersonflag === "2" ||
                this.acctInfo.specialpersonflag === "3" ||
                this.acctInfo.specialpersonflag === "4"
            ) {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入收入来源"));
                }
            }
            if (!this.$util.isEmpty(value)) {
                this.$util.validateGeneral(rule, value, callback, "收入来源");
            } else {
                callback();
            }
        },
        validateBeneficiary(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入受益人姓名"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateBeneficiarytype(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择受益人证件类型"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateBeneficiaryno(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入受益人证件号码"));
                } else {
                    this.$util.validateCertNo(
                        rule,
                        value,
                        callback,
                        this.acctInfo.benefitcertificatetype
                    );
                }
            } else {
                callback();
            }
        },
        // 用户本人有效期长期有效是否展示
        changeSelfValidateFn() {
            this.dateSet.val = this.acctInfo.validdate
                ? format(this.acctInfo.validdate, "YYYY-MM-DD")
                : "";
            // orc关闭且用户本人证件类型为身份证时
            if (
                !this.ocrOnOff &&
                (this.acctInfo.certificatetype == "00" || this.acctInfo.certificatetype == "0B")
            ) {
                const isFlag = this.$util.isOver46YearsOld(
                    this.acctInfo.certificateno,
                    this.acctInfo.birthday.replace(/-/g, "")
                );
                this.dateSet = Object.assign({}, this.dateSet);
                if (isFlag) {
                    this.dateSet.longHidden = false;
                } else {
                    this.dateSet.longHidden = true;
                    if (this.dateSet.val == "9999-12-31") {
                        this.dateSet.val = "";
                        this.acctInfo.validdate = "";
                        this.$nextTick(() => {
                            this.$refs.acctInfo.validateField("validdate");
                        });
                    }
                }
            } else {
                this.dateSet.longHidden = false;
            }
        },
        // 改变代理人证件类型和代理人证件号码，出生日期，性别，证件有效期需要控制
        changeProxyTypeFn() {
            // 代理人证件类型为身份证时
            if (this.acctInfo.proxycertype == "00" || this.acctInfo.proxycertype == "0B") {
                this.$set(this.proxyDateSetBirth, "dis", true);
                this.proxySexDis = true;
                this.acctInfo.proxysex = this.getSex(this.acctInfo.proxycerno);
                this.$util.validateCertNo(
                    "",
                    this.acctInfo.proxycerno,
                    () => {
                        this.$set(
                            this.proxyDateSetBirth,
                            "val",
                            this.$util.fmtDate(
                                this.$util.getBirthdate(
                                    this.acctInfo.proxycerno,
                                    this.acctInfo.proxycertype
                                )
                            )
                        );
                        this.acctInfo.proxybirthday = this.proxyDateSetBirth.val.replace(/-/g, "");
                        this.changeProxyValidateFn();
                    },
                    this.acctInfo.proxycertype
                );
            } else {
                this.proxyvaliddate.longHidden = false;
                this.$set(this.proxyDateSetBirth, "dis", false);
                this.proxySexDis = false;
            }
        },
        // 代理人证件有效期长期有效是否展示
        changeProxyValidateFn() {
            this.proxyvaliddate.val = this.acctInfo.proxyvaliddate
                ? format(this.acctInfo.proxyvaliddate, "YYYY-MM-DD")
                : "";
            const isFlag = this.$util.isOver46YearsOld(
                this.acctInfo.proxycerno,
                this.proxyDateSetBirth.val.replace(/-/g, "")
            );
            this.proxyvaliddate = Object.assign({}, this.proxyvaliddate);
            if (isFlag) {
                this.proxyvaliddate.longHidden = false;
            } else {
                this.proxyvaliddate.longHidden = true;
                if (this.proxyvaliddate.val == "9999-12-31") {
                    this.proxyvaliddate.val = "";
                    this.acctInfo.proxyvaliddate = "";
                    this.$nextTick(() => {
                        this.$refs.acctInfo.validateField("proxyvaliddate");
                    });
                }
            }
        },
        // 改变受益人证件类型和受益人证件号码，出生日期，性别，证件有效期需要控制
        changeBenefitTypeFn() {
            // 受益人为非本人且证件类型为身份证时
            if (
                this.acctInfo.benefisself == "0" &&
                (this.acctInfo.benefitcertificatetype == "00" ||
                    this.acctInfo.benefitcertificatetype == "0B")
            ) {
                this.$set(this.beneficiaryBirthSet, "dis", true);
                this.benefitSexDis = true;
                this.acctInfo.benefitsex = this.getSex(this.acctInfo.benefitcertificateno);
                if (!this.acctInfo.benefitcertificateno.includes("*")) {
                    this.$util.validateCertNo(
                        "",
                        this.acctInfo.benefitcertificateno,
                        () => {
                            this.$set(
                                this.beneficiaryBirthSet,
                                "val",
                                this.$util.fmtDate(
                                    this.$util.getBirthdate(
                                        this.acctInfo.benefitcertificateno,
                                        this.acctInfo.benefitcertificatetype
                                    )
                                )
                            );
                            this.acctInfo.benefitbirthday = this.beneficiaryBirthSet.val.replace(
                                /-/g,
                                ""
                            );
                            this.changeBenefitValidateFn();
                        },
                        this.acctInfo.benefitcertificatetype
                    );
                }

                setTimeout(() => {
                    this.$refs.acctInfo.clearValidate(["benefitsex", "benefitbirthday"]);
                }, 1000);
            } else {
                // 离开输入框，并且证件类型一致，恢复脱敏数据
                let info = this.$cache.getUser();
                if (
                    this.acctInfo.benefitcertificateno == "" &&
                    info.benefitcertificatetype == this.acctInfo.benefitcertificatetype
                ) {
                    this.acctInfo.benefitcertificateno = info.benefitcertificateno;
                }
                this.beneficiaryDateSet.longHidden = false;
                this.$set(this.beneficiaryBirthSet, "dis", false);
                this.benefitSexDis = false;
            }
        },
        focusBenefitTypeFn() {
            // 聚焦到输入框时，立即清空输入框中的脱敏数据
            if (this.acctInfo.benefitcertificateno.includes("*")) {
                this.acctInfo.benefitcertificateno = "";
            }
        },
        // 受益人证件有效期长期有效是否展示
        changeBenefitValidateFn() {
            this.beneficiaryDateSet.val = this.acctInfo.benefitvaliddate
                ? format(this.acctInfo.benefitvaliddate, "YYYY-MM-DD")
                : "";
            const isFlag = this.$util.isOver46YearsOld(
                this.acctInfo.benefitcertificateno,
                this.beneficiaryBirthSet.val.replace(/-/g, "")
            );
            this.beneficiaryDateSet = Object.assign({}, this.beneficiaryDateSet);
            if (isFlag) {
                this.beneficiaryDateSet.longHidden = false;
            } else {
                this.beneficiaryDateSet.longHidden = true;
                if (this.beneficiaryDateSet.val == "9999-12-31") {
                    this.beneficiaryDateSet.val = "";
                    this.acctInfo.benefitvaliddate = "";
                    this.$nextTick(() => {
                        this.$refs.acctInfo.validateField("benefitvaliddate");
                    });
                }
            }
        },
        // 改变控制人证件类型和控制人证件号码，出生日期，性别，证件有效期需要控制
        changeActualctrlTypeFn() {
            // 控制人为非本人且证件类型为身份证时
            if (
                this.acctInfo.actualisself == "0" &&
                (this.acctInfo.actualctrlcertype == "00" || this.acctInfo.actualctrlcertype == "0B")
            ) {
                this.$set(this.actualctrlBirthSet, "dis", true);
                this.actualSexDis = true;
                this.acctInfo.actualctrlsex = this.getSex(this.acctInfo.actualctrlcerno);
                if (!this.acctInfo.actualctrlcerno.includes("*")) {
                    this.$util.validateCertNo(
                        "",
                        this.acctInfo.actualctrlcerno,
                        () => {
                            this.$set(
                                this.actualctrlBirthSet,
                                "val",
                                this.$util.fmtDate(
                                    this.$util.getBirthdate(
                                        this.acctInfo.actualctrlcerno,
                                        this.acctInfo.actualctrlcertype
                                    )
                                )
                            );
                            this.acctInfo.actualctrlbirthday = this.actualctrlBirthSet.val.replace(
                                /-/g,
                                ""
                            );
                            this.changeActualctrlValidateFn();
                        },
                        this.acctInfo.actualctrlcertype
                    );
                }
                setTimeout(() => {
                    this.$refs.acctInfo.clearValidate(["actualctrlsex", "actualctrlbirthday"]);
                }, 1000);
            } else {
                // 离开输入框，并且证件类型一致，恢复脱敏数据
                let info = this.$cache.getUser();
                if (
                    this.acctInfo.actualctrlcerno == "" &&
                    info.actualctrlcertype == this.acctInfo.actualctrlcertype
                ) {
                    this.acctInfo.actualctrlcerno = info.actualctrlcerno;
                }
                this.actualctrlDateSet.longHidden = false;
                this.$set(this.actualctrlBirthSet, "dis", false);
                this.actualSexDis = false;
            }
        },
        focusActualctrlTypeFn() {
            // 聚焦到输入框时，立即清空输入框中的脱敏数据
            if (this.acctInfo.actualctrlcerno.includes("*")) {
                this.acctInfo.actualctrlcerno = "";
            }
        },
        // 控制人证件有效期长期有效是否展示
        changeActualctrlValidateFn() {
            this.actualctrlDateSet.val = this.acctInfo.actualctrlvalidate
                ? format(this.acctInfo.actualctrlvalidate, "YYYY-MM-DD")
                : "";
            const isFlag = this.$util.isOver46YearsOld(
                this.acctInfo.actualctrlcerno,
                this.actualctrlBirthSet.val.replace(/-/g, "")
            );
            this.actualctrlDateSet = Object.assign({}, this.actualctrlDateSet);
            if (isFlag) {
                this.actualctrlDateSet.longHidden = false;
            } else {
                this.actualctrlDateSet.longHidden = true;
                if (this.actualctrlDateSet.val == "9999-12-31") {
                    this.actualctrlDateSet.val = "";
                    this.acctInfo.actualctrlvalidate = "";
                    this.$nextTick(() => {
                        this.$refs.acctInfo.validateField("actualctrlvalidate");
                    });
                }
            }
        },
        changeInfoFn(key) {
            // 离开输入框，恢复脱敏数据
            let info = this.$cache.getUser();
            if (this.acctInfo[key] == "") {
                this.acctInfo[key] = info[key];
            }
        },
        focusInfoFn(key) {
            // 聚焦到输入框时，立即清空输入框中的脱敏数据
            if (this.acctInfo[key].includes("*")) {
                this.acctInfo[key] = "";
            }
        },
        validateBeneficiarydate(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择受益人证件有效期"));
                } else {
                    if (Number(value) < Number(format(new Date(), "YYYYMMDD"))) {
                        callback(new Error("受益人有效期必须大于当前日期，请重新选择"));
                    } else {
                        callback();
                    }
                }
            } else {
                callback();
            }
        },
        // 根据身份证号判断性别
        getSex(psidno) {
            let sexno = "";
            if (psidno.length === 18) {
                sexno = psidno.substring(16, 17);
            } else if (psidno.length === 15) {
                sexno = psidno.substring(14, 15);
            } else {
                return "";
            }
            const tempid = sexno % 2;
            return tempid === 0 ? "2" : "1";
        },
        /* 校验代理人姓名 */
        checkProxyName(rule, value, callback) {
            if (this.$util.isEmpty(value)) {
                callback(new Error("请输入代理人姓名"));
            } else {
                this.$util.validateName(rule, value, callback);
            }
            callback();
        },
        checkProxyType(rule, value, callback) {
            if (this.$util.isEmpty(value)) {
                callback(new Error("请选择代理人证件类型"));
            }
            callback();
        },
        checkProxyCertNo(rule, value, callback) {
            if (this.$util.isEmpty(value)) {
                callback(new Error("请输入代理人证件号码"));
            } else {
                this.$util.validateCertNo(rule, value, callback, this.acctInfo.proxycertype);
            }
            callback();
        },
        checkProxyVailddate(rule, value, callback) {
            if (this.$util.isEmpty(value)) {
                callback(new Error("请选择代理人证件有效期"));
            }
            callback();
        },
        checkProxyBirthdate(rule, value, callback) {
            if (this.$util.isEmpty(value)) {
                callback(new Error("请选择代理人出生日期"));
            }
            callback();
        },
        validateActualctrlname(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入控制人姓名"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateActualctrlidtype(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择控制人证件类型"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateActualctrl(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入控制人证件号码"));
                } else {
                    this.$util.validateCertNo(
                        rule,
                        value,
                        callback,
                        this.acctInfo.actualctrlcertype
                    );
                }
            } else {
                callback();
            }
        },
        validatePostCode(rule, value, callback) {
            this.$util.validatePostCode(rule, value, callback);
        },
        validatePostCode2(rule, value, callback) {
            this.$util.validatePostCode(rule, value, callback);
        },
        validateVocationsupple(rule, value, callback) {
            if (
                (this.acctInfo.vocationcode === "14" || this.acctInfo.vocationcode === "29") &&
                !value
            ) {
                callback(new Error("请输入职业补充信息"));
            } else {
                callback();
            }
        },
        validateDeliverway(rule, value, callback) {
            if (
                !this.$util.isEmpty(this.acctInfo.delivertype) &&
                this.acctInfo.delivertype !== "1" &&
                (!value || value.length === 0)
            ) {
                callback(new Error("请选择对账单寄送方式"));
            } else {
                callback();
            }
        },
        validateMobile(rule, value, callback) {
            if (value.includes("*")) {
                callback();
            } else {
                this.$util.validateMobile(rule, value, callback);
            }
        },
        validateFax(rule, value, callback) {
            this.acctInfo[rule.validName] = value.replace(/[^0-9*]/g, "");
            value = this.acctInfo[rule.validName];
            if (rule.validName == "fax") {
                if (this.acctInfo.deliverway.includes("2")) {
                    this.$util.validateFaxNum(rule, value, callback);
                } else {
                    callback();
                }
            } else if (rule.validName == "telno") {
                if (this.acctInfo.telno.trim()) {
                    this.$util.validateFaxNum(rule, value, callback);
                } else {
                    callback();
                }
            } else if (rule.validName == "benefittelno") {
                if (this.acctInfo.benefittelno.trim()) {
                    this.$util.validateFaxNum(rule, value, callback);
                } else {
                    callback();
                }
            } else if (rule.validName == "actualctrltelno") {
                if (this.acctInfo.actualctrltelno.trim()) {
                    this.$util.validateFaxNum(rule, value, callback);
                } else {
                    callback();
                }
            } else {
                this.$util.validateFaxNum(rule, value, callback);
            }
        },
        validateDesEmail(rule, value, callback) {
            this.$util.validateDesEmail(rule, value, callback);
        },
        validateEmail(rule, value, callback) {
            this.$util.validateEmail(rule, value, callback);
        },
        async gotoSub() {
            const _this = this;
            _this.dialogVisible = false;
            if (this.acctInfo.birthday && this.acctInfo.proxyname == "") {
                const _date = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
                if (Number(this.acctInfo.birthday) >= Number(_date)) {
                    _this
                        .$alert(
                            "根据您的证件信息，您属于未成年人，无代理人信息时，无法修改用户信息！",
                            "",
                            {
                                confirmButtonText: "确定",
                                type: "warning",
                                callback: (action) => {
                                    _this.$router.push({ name: "acctManager" });
                                }
                            }
                        )
                        .then(() => {
                            return false;
                        })
                        .catch(() => {
                            return false;
                        });
                    return;
                }
            }
            _this.acctInfo.benefittelnocycode = _this.acctInfo.benefisself == "0" ? "86" : "";
            _this.acctInfo.actelnocycode = _this.acctInfo.actualisself == "0" ? "86" : "";
            let _obj = Object.assign({}, _this.acctInfo);
            // let _obj = _this.$util.getObjParam(
            //     _this.acctInfo,
            //     "nonresiflag,certificateno,validdate,specialpersonflag,nationality,vocationcode,delivertype,deliverway,sex,educationlevel,postcode,email,annualincome,telno,telareacode,telcycode,fax,faxcycode,faxareacode,address,livingaddress,remark,birthday,pwd,benefisself,livingaddressprovince,livingaddresscity,livingaddresscounty,assetssource,benefitname,benefitcertificatetype,benefitcertificateno,benefitvaliddate,benefitsex,benefitbirthday," +
            //         "benefitvocation,benefittelnocycode,benefittelnoareacode,benefittelno,benefitcountry,benefitaddressprovince,benefitaddresscity,benefitaddresscounty," +
            //         "benefitaddress,benefitemail,benefitpostcode,benefrelation,actualisself,actualctrlname,actualctrlcertype,actualctrlcerno,actualctrlvalidate,actualctrlsex,actualctrlbirthday,actualctrlvocation," +
            //         "actelnocycode,actelnoareacode,actualctrltelno,actualctrlcountry,actualctrladdrprovince,actualctrladdrcity,actualctrladdrcounty,actualctrladdr,actualctrlemail,actualctrlpostcode,actualrelation,tradingmethod"
            // );
            _obj.isdigniaryorceo = _this.acctInfo.specialpersonflag;
            _obj.livingcountry = _this.acctInfo.livingcountry;
            const info = this.$cache.getUser();
            // 针对存量用户，邮寄地址(客户地址)address不同步，不做修改。
            if (!info.address) {
                _obj.address = _this.acctInfo.livingaddress;
            } else {
                _obj.address = info.address;
            }
            _obj.nationality = _this.acctInfo.nationality;
            _obj.otherprovince = _this.acctInfo.province;
            _obj.location =
                _obj.nationality === "CN"
                    ? this.$cache.getDict("190021", _obj.livingaddressprovince)
                    : this.$cache.getDict("120109", _obj.nationality);
            _obj.belongregion = _obj.nationality === "CN" ? "中国" : "外国";
            if (!_this.isMobile) {
                _obj.mobileno = _this.acctInfo.mobileno;
            }
            _obj.tradepwd = this.$util.enc(_obj.pwd);
            if (_obj.vocationcode === "14" || _obj.vocationcode === "29") {
                _obj.vocationsupple = _this.acctInfo.vocationsupple;
            }
            let deliverway = _this.acctInfo.deliverway && _this.acctInfo.deliverway.join(",");
            _obj.deliverway = deliverway;
            if (this.acctInfo.validdate) {
                _obj.validtype = 0;
                if (
                    this.acctInfo.validdate == "99991231" ||
                    this.acctInfo.validdate == "长期有效"
                ) {
                    _obj.validtype = 1;
                    this.acctInfo.validdate = "99991231";
                }
            } else {
                _obj.validtype = 2;
            }
            if (this.acctInfo.actualctrlvalidate) {
                _obj.actualctrlvalitype = 0;
                if (
                    this.acctInfo.actualctrlvalidate == "99991231" ||
                    this.acctInfo.actualctrlvalidate == "长期有效"
                ) {
                    _obj.actualctrlvalitype = 1;
                    this.acctInfo.actualctrlvalidate = "99991231";
                }
            } else {
                _obj.actualctrlvalitype = 2;
            }
            if (this.acctInfo.benefitvaliddate) {
                _obj.benefitvalidtype = 0;
                if (
                    this.acctInfo.benefitvaliddate == "99991231" ||
                    this.acctInfo.benefitvaliddate == "长期有效"
                ) {
                    _obj.benefitvalidtype = 1;
                    this.acctInfo.benefitvaliddate = "99991231";
                }
            } else {
                _obj.benefitvalidtype = 2;
            }

            if (this.acctInfo.proxyvaliddate) {
                _obj.proxyvaliddatetype = 0;
                if (
                    this.acctInfo.proxyvaliddate == "99991231" ||
                    this.acctInfo.proxyvaliddate == "长期有效"
                ) {
                    _obj.proxyvaliddatetype = 1;
                    this.acctInfo.proxyvaliddate = "99991231";
                }
            } else {
                _obj.proxyvaliddatetype = 2;
            }
            const accRistRes = await userApi.acctRiskListManage({
                invtp: _this.acctInfo.invtp,
                opaction: "Q",
                certificatetype: this.acctInfo.certificatetype,
                certificateno: this.acctInfo.certificateno
            });
            if (accRistRes.data.length > 0) {
                if (_this.fn) {
                    _this
                        .$alert("账号为风险客户，请联系客服进行修改操作!", "信息提示", {
                            confirmButtonText: "确定",
                            type: "warning",
                            callback: (action) => {
                                this.$router.push({
                                    name: "modifyinfo"
                                });
                            }
                        })
                        .then(() => {
                            return false;
                        })
                        .catch(() => {
                            return false;
                        });
                    return false;
                }
                _this.$message.warning("账号为风险客户，请联系客服进行修改操作!");
                return false;
            } else {
                const res = await userApi.updAcctInfo(_obj);
                if (res.data.appsheetserialno) {
                    _this.$cache.refreshUser(() => {
                        const message1 = "个人信息已更新成功";
                        const message2 = _this.fn ? "" : "秒后回到个人信息页面";
                        const data = {
                            type: "success",
                            message1: message1,
                            message2: message2,
                            onClose: function () {
                                if (_this.fn) {
                                    _this.$emit("fn-back", true);
                                } else {
                                    _this.$router.push({
                                        name: "acctManager",
                                        query: { activeIndex: "1" }
                                    });
                                }
                            }
                        };
                        if (!_this.fn) {
                            data.message1 = "个人信息已更新成功，";
                            data.number = 3;
                        }
                        _this.$handleAutoCloseMessage(data);
                    });
                }
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            const _this = this;
            // this.$util.highriskareaquery(this.acctInfo.nationality,this.acctInfo.province,res => {
            //     if(res == "1") {
            //         this.$alert("尊敬的客户您好，您的受益人所在的国籍为反洗钱法规确认的高危地区，请您联系客服修改！");
            //         return;
            //     }
            // })
            if (this.ocrUploadFlag === "5") {
                this.$alert("请先上传证件照");
                return;
            }
            if (this.acctInfo.deliverway.includes("2") && this.acctInfo.faxcycode === "") {
                this.$alert("请选择国家码");
                return;
            }
            if (
                this.acctInfo.deliverway.includes("2") &&
                this.acctInfo.faxcycode === "86" &&
                this.acctInfo.faxareacode === ""
            ) {
                this.$alert("请选择地区码！");
                return;
            }
            _this.setAddress();
            if (!this.checkAddressInfo() || !this.checkBenefActualInfo()) {
                return;
            }
            const _date = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
            if (
                this.acctInfo.proxybirthday != "" &&
                Number(this.acctInfo.proxybirthday) >= Number(_date)
            ) {
                this.$alert("代理人需为成年人！", "温馨提示");
                return false;
            }
            _this.$refs[formName].validate((valid, obj) => {
                if (valid) {
                    _this.dialogVisible = true;
                    _this.checked = false;
                } else {
                    this.$errorScroll(_this, obj);
                }
            });
        },
        // 再次校验证件号码
        checkCertNoAgain() {
            this.$refs.acctInfo.validateField("certNo");
        },
        // 检查存量客户性别、证件有效期、出生日期是否为空
        checkUser(validdate, info) {
            let _x = "";
            if (!this.$util.isEmpty(validdate)) {
                if (Number(format(new Date(), "YYYYMMDD")) > Number(validdate)) {
                    _x += "证件有效期已过期";
                }
            }
            if (this.$util.isEmpty(info.sex)) {
                if (!this.$util.isEmpty(_x)) {
                    _x += "，性别为空";
                } else {
                    _x += "性别为空";
                }
            }
            if (this.$util.isEmpty(validdate)) {
                if (_x != "") {
                    _x += "，证件有效期为空";
                } else {
                    _x += "证件有效期为空";
                }
            }
            if (this.$util.isEmpty(info.birthday)) {
                if (_x != "") {
                    _x += "，出生日期为空";
                } else {
                    _x += "出生日期为空";
                }
            }
            return _x;
        },
        getOcrOpenStatus() {
            this.ocrOnOff = this.$cache.getCompanyInfoParam("88202302").includes("A84");
            // this.ocrOnOff=true // 临时代码
            if (this.ocrOnOff) {
                this.dateSet.dis = true;
            }
        },
        gotoUpdOcr() {
            // 判断证件类型是否为身份证
            if (this.acctInfo.certificatetype !== "00") {
                this.$message.warning("该证件类型不支持线上操作");
                return;
            }
            // const _this = this;
            this.ocrShow = true;
            // this.$router.push({
            //     name: "ocrinfoupd",
            //     query: { certificatetype: _this.acctInfo.certificatetype },
            // });
        },
        validateMin(rule, value, callback) {
            if (this.$util.isEmpty(value)) {
                callback(new Error("请选择证件有效期"));
            } else if (Number(value) < Number(format(new Date(), "YYYYMMDD"))) {
                callback(new Error("证件有效期必须大于当前日期，请重新选择"));
            } else {
                callback();
            }
        },
        handleAnnualIncomeInput(value) {
            // 只允许输入数字
            this.acctInfo.annualincome = value.replace(/[^0-9]/g, "");
        },
        specificnaturalper() {
            var _param = {
                invtp: "1",
                certificatetype: this.acctInfo.certificatetype,
                custfullname: this.acctInfo.custname,
                action: "Q"
            };
            this.$util.specificnaturalper(_param, (res) => {
                if (res != null) {
                    for (let i in this.isdigniaryorceo) {
                        if (
                            this.isdigniaryorceo[i].subitem == "0" ||
                            this.isdigniaryorceo[i].subitem == "A"
                        ) {
                            this.isdigniaryorceo.splice(i, 0);
                            i--;
                        }
                    }
                }
            });
        },
        modifyPhone() {
            // 修改手机号
            this.$router.push({
                name: "acctManager",
                query: {
                    activeIndex: "2"
                },
                params: { next: "mobile" }
            });
        },
        // 根据配置参数限制字典选项（通用处理）
        applyDictLimitConfig() {
            try {
                const accountInfo = this.$cache.getParamValue("account_open_control");
                if (this.$util.isEmpty(accountInfo)) return;
                const fields = accountInfo.fields || [];
                // key 与 options 属性名的映射关系（根据 getDict 赋值语句整理）
                const keyMap = {
                    deliverway: "deliverways", // dict: 100013
                    delivertype: "delivertype", // dict: 110046
                    benefisself: "benefisself", // dict: 120137
                    benefitcertificatetype: "benefitcertificatetype", // dict: 130007
                    benefitsex: "benefitsex", // dict: 110059
                    benefitvocation: "benefitvocation", // dict: 150141
                    vocationcode: "vocationcode", // dict: 150141
                    educationlevel: "educationlevel", // dict: 20011
                    isdigniaryorceo: "isdigniaryorceo", // dict: 120200
                    specialpersonflag: "specialpersonflag", // dict: 120200
                    telareacode: "telareacode", // dict: 150137
                    sex: "sex", // dict: 110059
                    actualisself: "actualisself", // dict: 120137
                    actualctrlsex: "actualctrlsex", // dict: 110059
                    actualctrlvocation: "actualctrlvocation", // dict: 150141
                    actualctrlcertype: "actualctrlcertype" // dict: 130007
                };
                fields.forEach((field) => {
                    const { key, dict, "dict-limit": dictLimit } = field;
                    if (!key || !dict || !dictLimit) return;
                    const prop = keyMap[key];
                    if (!prop || !this[prop]) return;
                    // 支持逗号分隔的多个值
                    const limitValues = dictLimit.split(",");
                    const dictItem = this.$cache.getDict(dict);
                    this[prop] = dictItem.filter((item) => limitValues.includes(item.subitem));
                });
            } catch (e) {
                console.error("解析 account_open_control 配置失败:", e);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";

.comp-user-info {
    padding-bottom: 20px;
    font-size: 14px;
    font-weight: normal;
    color: var(--color-text-primary);
    box-sizing: border-box;
    border: 1px solid var(--color-border-base);
    .comp-user-info-header {
        margin: 17px 19px 0px;
        padding-bottom: 21px;
        background: #ffffff;
        font-size: 20px;
        font-weight: 500;
        color: var(--color-text-primary);
        box-sizing: border-box;
        border-bottom: 1px solid var(--color-border-base);
    }
    .user-address ::v-deep label.el-form-item__label {
        font-size: 14px;
        color: var(--color-text-primary);
        margin-right: 8px;
        &:before {
            display: inline;
            content: "*";
            color: $color-c;
            margin-right: 2px;
        }
    }
    .acct-box {
        padding: 20px 10px;

        .el-form-item {
            margin-bottom: 18px;

            &.is-required .el-form-item__label:before {
                display: inline;
                content: "";
            }
            &.required ::v-deep .el-form-item__label:before {
                display: inline;
                content: "*";
                color: $color-c;
                margin-right: 2px;
            }
        }
        .btn-group {
            text-align: center;
            width: 100%;
            margin-top: 20px;
            .cancel-btn {
                width: 180px;
                height: 42px;
                border-radius: 2px;
                background: var(--color-border-base);
                border: 1px solid var(--color-border-base);
                color: var(--color-text-regular);
                cursor: pointer;
            }

            .confirm-btn {
                margin-left: 40px;
                width: 180px;
                height: 42px;
                border-radius: 2px;
                background: var(--color-primary);
                border: 1px solid var(--color-primary);
                color: #ffffff;
                cursor: pointer;
            }
        }

        .el-select {
            width: 70%;
            margin-right: 20px;

            .el-input {
                width: 100%;
            }
        }

        .el-input,
        .el-textarea {
            width: 70%;

            .el-input__inner {
                height: 38px;
                line-height: 36px;
            }
        }

        .vailddate-box {
            .el-select {
                width: 40%;

                .el-input {
                    width: 100%;
                }
            }

            .el-input,
            .el-textarea {
                width: 40%;
            }

            .comp-date-picker {
                width: 100%;

                .el-input {
                    width: 40%;
                }
            }
        }

        .el-form-item__label {
            padding: 0;
            line-height: 38px;
        }
    }

    .check-style {
        margin-right: 10px;
    }

    .text-con {
        font-size: 16px;
        font-weight: normal;
        color: var(--color-text-primary);
    }

    .modify-phone {
        margin-left: 50px;
        font-size: 14px;
        color: var(--color-primary);
        cursor: pointer;
    }

    .title-bar {
        font-size: 18px;
        font-weight: 500;
        color: var(--color-text-primary);
        padding-bottom: 18px;
        padding-left: 11px;
        display: flex;
        align-items: center;

        .bar {
            width: 3.71px;
            height: 16px;
            background: var(--color-primary);
            margin-right: 6.5px;
        }
    }
}
</style>
